<div *ngIf="isActivityInProgress" class="h-34 activity-status ml-22 mr-22" [ngClass]="isActivityInProgress? 'mt--4' : ''">
  <mat-progress-bar class="mt-2 progress-bar" mode="indeterminate"></mat-progress-bar>
  <div class="flex flex-row justify-center items-center">
    <div class="flex flex-row main-container">
      <ng-container *ngIf="isComponentAvailable; else componentNotAvailable">
        <span class="fw-600">
          {{(data?.status | isIn: DR_STATES) ? getDRStatus(data?.status) : data?.status | titlecase}} {{isActivityInProgress[0]?.name}}
        </span>
        <div popup-host></div>
        <span (mouseenter)="onMouseEnter($event)">
          <mat-icon svgIcon="info" class="icon-md ml-16 mt-2"></mat-icon>
        </span>
      </ng-container>
      <ng-template #componentNotAvailable>
        <span class="fw-600">
          {{'INSTANCE_DETAILS.DEPLOYING' | transloco }}...
        </span>
      </ng-template>
    </div>
  </div>
</div>
<div class="instance-details-container mt-26 pl-26 pr-26 pb-20" *ngIf="!isLoading">
  <div class="mat-body fw-500">
    <mat-tab-group (selectedTabChange)="onTabChange($event)" animationDuration="0ms">
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.id}">{{'INSTANCE_DETAILS.OVERVIEW' | transloco }}</span>
        </ng-template>
        <div class="mat-subtitle-2 fw-700 fs-18">{{'INSTANCE_DETAILS.GENERAL' | transloco }}</div>
          <div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.SOLUTION' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="solution?.name; else loader" class="val fw-600 w-300px">{{solution?.name}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.name; else loader" class="val fw-600">{{getBlueprints?.name}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.REGION' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="(data?.region || data?.regionPair); else loader" class="val fw-600">{{data?.region || data?.regionPair}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_SUMMARY.VERSION' | transloco }}</div>:&nbsp;
                  <div class="val fw-600">{{solutionVersion && solutionVersion?.version? solutionVersion?.version : ('BLUEPRINT_SUMMARY.NA' | transloco)}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col hide">
                <!-- <div class="label-text flex mt-24 flex flex-row">
                  <div class="key">{{ 'INSTANCE_DETAILS.RELEASE_NOTES' | transloco }}</div>:&nbsp;
                  <div class="val fw-600 flex flex-row view-release-notes">
                    <ng-container *ngIf="serviceVersions || solutionVersion; else loader">
                      <mat-icon svgIcon="open_in_new" class="icon-sm mt-2 mr-10 cursor-pointer" (click)="navigateToUrl(solutionVersion?.releaseNotes)"></mat-icon>
                      <a class="view-release-internal-link mat-body cursor-pointer fw-600" [href]="solutionVersion?.releaseNotes" target="_blank">{{'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES' | transloco}}</a>
                      <mat-icon *ngIf="'BLUEPRINT_SUMMARY.VIEW_RELEASE_NOTES'" (click)="onCopyId(solutionVersion?.releaseNotes)"  [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-md ml-10 cursor-pointer"></mat-icon>
                    </ng-container>
                  </div>
                </div> -->
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.UPDATED_ON' | transloco }}</div>:&nbsp;
                  <div *ngIf="data?.dateUpdated; else loader" class="val fw-600">{{data?.dateUpdated | date: 'dd MMM yyyy, HH:mm' + ' UTC'}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.CREATED_ON' | transloco }}</div>:&nbsp;
                  <div *ngIf="data?.dateCreated; else loader" class="val fw-600">{{data?.dateCreated | date: 'dd MMM yyyy, HH:mm' + ' UTC'}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col hide">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.ENVIRONMENT' | transloco }}</div>:&nbsp;
                  <div *ngIf="data?.deploymentClass === devDeploymentClass || data?.environment; else loader" class="val fw-600">{{data?.environment ? data?.environment : 'INSTANCE_STATUS.NA' | transloco}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>

            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.CREATED_BY' | transloco }}</div>:&nbsp;
                  <div class="val fw-600">{{ data?.createdBy ? data.createdBy : ('BLUEPRINT_SUMMARY.NA' | transloco) }}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.OVERVIEW_MODIFIED_BY' | transloco }}</div>:&nbsp;
                  <div class="val fw-600">{{ data?.modifiedBy ? data.modifiedBy : ('BLUEPRINT_SUMMARY.NA' | transloco) }}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="mat-headline fw-700 fs-18 instance-font mt-42 mb-12">{{ 'INSTANCE_DETAILS.INSTANCE_DETAILS' | transloco }}</div>
          <mat-divider class="neutral-blue-6"></mat-divider>
          <div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.INSTANCE_ID' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <mat-icon *ngIf="data?.id" class="icon-sm w-18 mr-6 ml-8 mt-4 cursor-pointer" svgIcon="open_in_new" (click)="openUrl()"></mat-icon>
                  <div class="overview-values fw-500 edit_hover_class">
                    <a href="javascript:void(0);" (click)="openUrl()" class="no-underline">{{data?.id ? data?.id : '-'}}</a>
                    <mat-icon *ngIf="data?.id" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.id)"></mat-icon>
                  </div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.RANDOM_SUFFIX' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.randomSuffix; else loader" class="val fw-600 w-300px">{{data?.randomSuffix}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.DEPLOYMENT_CLASS' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.deploymentClass; else loader" class="val fw-600">{{data?.deploymentClass}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.DATA_ZONE' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.dataZone; else loader" class="val fw-600 w-300px">{{data?.dataZone}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.PRIMARY_CLOUD_REGION' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="(data?.primaryCloudRegion || data?.primaryRegion); else loader" class="val fw-600">{{data?.primaryCloudRegion || data?.primaryRegion}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.SECONDARY_CLOUD_REGION' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="!hasSecondaryRegion; else showData" class="val fw-600 w-300px">{{'-'}}</div>
                  <ng-template #showData>
                    <div *ngIf="(data?.secondaryCloudRegion || data?.secondaryRegion); else loader" class="val fw-600 w-300px">{{data?.secondaryCloudRegion || data?.secondaryRegion}}</div>
                  </ng-template>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col hide">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.MANAGEMENT_TYPE' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div class="val fw-600">
                    {{data?.managementType ? data?.managementType : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                  </div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col hide">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.EXTERNAL_ORIGINATION' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div class="val fw-600 w-300px">-</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_NAME' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="getBlueprints?.name; else loader" class="val fw-600">{{getBlueprints?.name}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.SERVICE_DEFINITION_ID' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="getBlueprints?.id; else loader" class="val fw-600">{{getBlueprints?.id}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col hide">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.DEPLOYMENT_ID' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.id; else loader" class="val fw-600">{{data?.latestDeploymentId? data?.latestDeploymentId : '-'}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
              <div class="right-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.CONFIGURATION_ID' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.id; else loader" class="val fw-600 w-300px">{{data?.configurationId? data?.configurationId : '-'}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="flex flex-row grid-flow-col">
              <div class="left-pane flex flex-col">
                <div class="label-text flex mt-24">
                  <div class="key">{{ 'INSTANCE_DETAILS.INSTANCE_TYPE' | transloco }}</div>
                  <div>:&nbsp;</div>
                  <div *ngIf="data?.id; else loader" class="val fw-600">{{data?.type? data?.type : '-'}}</div>
                </div>
                <ng-template #loader>
                  <div class="pl-6 skeleton-loader">
                    <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !isEndpointAvailable}">{{'INSTANCE_DETAILS.ENDPOINTS' | transloco }}</span>
        </ng-template>
        <ng-container *ngIf="isEndpointAvailable; else showNotificationEndpoint">
          <div *ngIf="accessTypeEndpoints?.length > 0" class="endpoints-container mt-20 m-2 p-8">
            <div class="pt-16 pl-20 fs-18 fw-700">{{'INSTANCE_DETAILS.UI_ENDPOINTS' | transloco}}</div>
            <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
              <div class="name-section pl-16">{{'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase}}</div>
              <div>{{'INSTANCE_DETAILS.DESCRIPTION' | transloco  | uppercase}}</div>
            </div>
            <div class="flex flex-col row-content ml-16 mr-16">
              <div *ngFor="let accessTypeEndpoint of accessTypeEndpoints" class="flex endpoint-row items-center pt-8 pb-8">
                <div class="flex name-section">
                  <div class="flex items-center endpoint-name p-6">
                    <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(accessTypeEndpoint?.url)"></mat-icon>
                    <a class="mat-body cursor-pointer fw-600 fs-16" [href]="accessTypeEndpoint?.url" target="_blank">{{accessTypeEndpoint?.name}}</a>
                    <mat-icon *ngIf="accessTypeEndpoint?.name" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer ml-10" (click)="onCopyId(accessTypeEndpoint?.url)"></mat-icon>
                  </div>
                </div>
                <div class="description" [title]="accessTypeEndpoint?.description">
                  {{accessTypeEndpoint?.description ? accessTypeEndpoint?.description : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="exploreTypeEndpoints?.length > 0" class="endpoints-container mt-20 m-2 p-8">
            <div class="pt-16 pl-20 fs-18 fw-700">{{'INSTANCE_DETAILS.API_ENDPOINTS' | transloco}}</div>
            <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
              <div class="name-section pl-16">{{'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase}}</div>
              <div>{{'INSTANCE_DETAILS.DESCRIPTION' | transloco  | uppercase}}</div>
            </div>
            <div class="flex flex-col row-content ml-16 mr-16">
              <div *ngFor="let exploreTypeEndpoint of exploreTypeEndpoints" class="flex endpoint-row items-center pt-8 pb-8">
                <div class="flex name-section">
                  <div class="flex items-center endpoint-name p-6">
                    <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(exploreTypeEndpoint?.url)"></mat-icon>
                    <a class="mat-body cursor-pointer fw-600 fs-16" [href]="exploreTypeEndpoint?.url" target="_blank">{{exploreTypeEndpoint?.name}}</a>
                    <mat-icon *ngIf="exploreTypeEndpoint?.name" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer ml-10" (click)="onCopyId(exploreTypeEndpoint?.url)"></mat-icon>
                  </div>
                </div>
                <div class="description" [title]="exploreTypeEndpoint?.description">
                  {{exploreTypeEndpoint?.description ? exploreTypeEndpoint?.description : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="configTypeEndpoints?.length > 0" class="endpoints-container mt-20 m-2 p-8">
            <div class="pt-16 pl-20 fs-18 fw-700">{{'INSTANCE_DETAILS.CONFIGURATION' | transloco}}</div>
            <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
              <div class="name-section pl-16">{{'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase}}</div>
              <div>{{'INSTANCE_DETAILS.DESCRIPTION' | transloco  | uppercase}}</div>
            </div>
            <div class="flex flex-col row-content ml-16 mr-16">
              <div *ngFor="let configTypeEndpoint of configTypeEndpoints" class="flex endpoint-row items-center pt-8 pb-8">
                <div class="flex name-section">
                  <div class="flex items-center endpoint-name p-6">
                    <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(configTypeEndpoint?.url)"></mat-icon>
                    <a class="mat-body cursor-pointer fw-600 fs-16" [href]="configTypeEndpoint?.url" target="_blank">{{configTypeEndpoint?.name}}</a>
                    <mat-icon *ngIf="configTypeEndpoint?.name" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer ml-10" (click)="onCopyId(configTypeEndpoint?.url)"></mat-icon>
                  </div>
                </div>
                <div class="description" [title]="configTypeEndpoint?.description">
                  {{configTypeEndpoint?.description ? configTypeEndpoint?.description : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="otherTypeEndpoints?.length > 0" class="endpoints-container mt-20 m-2 p-8">
            <div class="pt-16 pl-20 fs-18 fw-700">{{'INSTANCE_DETAILS.OTHER' | transloco}}</div>
            <div class="flex flex-row endpoints-header items-center mt-20 mb-6 ml-16 mr-16 h-32 fs-12 fw-700">
              <div class="name-section pl-16">{{'INSTANCE_DETAILS.ENDPOINTS' | transloco | uppercase}}</div>
              <div>{{'INSTANCE_DETAILS.DESCRIPTION' | transloco  | uppercase}}</div>
            </div>
            <div class="flex flex-col row-content ml-16 mr-16">
              <div *ngFor="let otherTypeEndpoint of otherTypeEndpoints" class="flex endpoint-row items-center pt-8 pb-8">
                <div class="flex name-section">
                  <div class="flex items-center endpoint-name p-6">
                    <mat-icon svgIcon="open_in_new" class="icon-md mr-10 cursor-pointer" (click)="navigateToUrl(otherTypeEndpoint?.url)"></mat-icon>
                    <a class="mat-body cursor-pointer fw-600 fs-16" [href]="otherTypeEndpoint?.url" target="_blank">{{otherTypeEndpoint?.name}}</a>
                    <mat-icon *ngIf="otherTypeEndpoint?.name" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" class="copy-icon icon-sm cursor-pointer ml-10" (click)="onCopyId(otherTypeEndpoint?.url)"></mat-icon>
                  </div>
                </div>
                <div class="description" [title]="otherTypeEndpoint?.description">
                  {{otherTypeEndpoint?.description ? otherTypeEndpoint?.description : ('BLUEPRINT_SUMMARY.NA' | transloco)}}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #showNotificationEndpoint>
          <div class="flex flex-col justify-center items-center mt-150">
            <mat-icon svgIcon="warning_amber"  class="icon-warn"></mat-icon>
            <h2><span class="mt-10">{{'INSTANCE_LIST.ENDPOINTS_NOT_AVALIABLE' | transloco}}</span></h2>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.solutionId}">{{'INSTANCE_DETAILS.SOLUTIONS' | transloco }}</span>
        </ng-template>
        <div class="flex flex-row flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.SOLUTION_NAME' | transloco}}</div>
            <div class="overview-values fw-500"><span class="pr-16">:</span>
              <span [matTooltip]="solution?.name"
              matTooltipPosition="above" matTooltipClass="tooltip-inner above fs-14">{{solution?.name ? solution?.name : '-'}}</span>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.SOLUTION_ID' | transloco}}</div>
            <span class="pr-16">:</span>
            <mat-icon *ngIf="data?.solutionId" class="icon-sm mt-2 mr-6 cursor-pointer" svgIcon="open_in_new" (click)="openUrlSolution(data?.solutionId)"></mat-icon>
            <div class="overview-values fw-500 edit_hover_class">
              <a href="javascript:void(0);" (click)="openUrlSolution(data?.solutionId)" class="no-underline">{{data?.solutionId ? data?.solutionId : '-'}}</a>
              <mat-icon *ngIf="data?.solutionId" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.solutionId)"></mat-icon>
            </div>
          </div>
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.SOLUTION_VERSION_ID' | transloco}}</div>
            <span class="pr-16">:</span>
            <mat-icon *ngIf="data?.solutionVersionId" class="icon-sm mt-2 mr-6 cursor-pointer" svgIcon="open_in_new" (click)="openUrlSolutionVersion(data?.solutionId)"></mat-icon>
            <div class="overview-values fw-500 edit_hover_class">
              <a href="javascript:void(0);" (click)="openUrlSolutionVersion(data?.solutionId)" class="no-underline">{{data?.solutionVersionId ? data?.solutionVersionId : '-'}}</a>
              <mat-icon *ngIf="data?.solutionVersionId" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.solutionVersionId)"></mat-icon>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !externalPackages?.references?.length}">{{'INSTANCE_DETAILS.CUSTOM_PACKAGE' | transloco }}</span>
        </ng-template>
        <div class="external-package p-24">
          <h3 *ngIf="externalPackages?.references?.length" class="mt-0 fs-18">{{externalPackages?.name ? externalPackages?.name : ''}}</h3>
          <div *ngIf="externalPackages?.references?.length; else noExternalPackagesFound" class="flex flex-col update-build">
            <div  class="flex flex-col border-radius">
              <table mat-table [dataSource]="dataSourceExternalPackages" matSort (matSortChange)="sortData($event)" multiTemplateDataRows class="mat-elevation-z8">
                <ng-container matColumnDef="menu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 expand-column"></th>
                  <td mat-cell *matCellDef="let data" class="arrow" [ngClass]="{'selected': data.arrowClick}">
                    <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8 cursor-pointer expand-column">
                      <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class" (click)="onExternalPackageArrowClick(data)"></mat-icon>
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="component">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 component" [ngClass]="{'selected': data.arrowClick}">
                    {{data.component | titlecase}} </td>
                </ng-container>
                <ng-container hidden matColumnDef="arrow">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16"></td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="tableColumns.length" [ngClass]="{'inner-table': element === expandedPackageElement}" class="inner-table">
                    <div class="example-element-detail flex-col" *ngIf="element === expandedPackageElement" [@detailExpand]="element === expandedPackageElement ? 'expanded' : 'collapsed'">
                      <ng-container *ngIf="dataSourceInnerImages?.length > 0 || dataSourceInnerPackages?.length > 0">
                        <div class="flex flex-row justify-between">
                          <div *ngIf="dataSourceInnerImages?.length > 0; else imagesNotFound" class="package-table-title">
                            <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</div>
                            <table mat-table [dataSource]="dataSourceInnerImages" multiTemplateDataRows class="mat-elevation logs">
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 name">
                                {{data?.name | titlecase}}</td>
                            </ng-container>
                            <ng-container matColumnDef="path">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 path" >{{data?.path | titlecase}} </td>
                            </ng-container>
                            <ng-container matColumnDef="version">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 version" >{{data?.version | titlecase}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                            </table>
                          </div>
                          <ng-template #imagesNotFound>
                            <div class="package-table-title">
                              <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation logs">
                                <ng-container matColumnDef="name">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container matColumnDef="path">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container matColumnDef="version">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container hidden matColumnDef="arrow">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                              </table>
                              <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                                <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                              </div>
                            </div>
                          </ng-template>
                          <div *ngIf="dataSourceInnerPackages?.length > 0; else packagesNotFound" class="package-table-title">
                            <div class="fs-16 mb-12 fw-600">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</div>
                            <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation logs">
                            <ng-container matColumnDef="name">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 name">
                                {{data?.name | titlecase}}</td>
                            </ng-container>
                            <ng-container matColumnDef="path">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 path" >{{data?.path | titlecase}} </td>
                            </ng-container>
                            <ng-container matColumnDef="version">
                              <th mat-header-cell *matHeaderCellDef class="fs-12 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                              <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-14 version" >{{data?.version | titlecase}} </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                            </table>
                          </div>
                          <ng-template #packagesNotFound>
                            <div class="package-table-title">
                              <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation logs">
                                <ng-container matColumnDef="name">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container matColumnDef="path">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container matColumnDef="version">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.UPDATE_BUILD.VERSION' | transloco | uppercase }} </th>
                                </ng-container>
                                <ng-container hidden matColumnDef="arrow">
                                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                              </table>
                              <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                                <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                              </div>
                            </div>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: tableColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedPackageElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
              </table>
            </div>
          </div>
          <ng-template #noExternalPackagesFound>
            <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
              <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
            </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !routeData?.length > 0 || data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.DEPLOYING || data?.status === DeployStatus.FAILED || data?.status === DeployStatus.TERMINATED || data?.status === DeployStatus.TERMINATING || data?.status === DeployStatus.INITIALIZING || data?.status === DeployStatus.INITIALIZED || data?.status === DeployStatus.INITIALIZE_FAILED || !sftp}">{{'TENANT_DETAILS.SFTP' | transloco }}</span>
        </ng-template>
         <mat-tab-group class="route-tabs" animationDuration="0ms">
          <mat-tab>
            <ng-template mat-tab-label>
              <span class="section-label fw-500">{{'INSTANCE_DETAILS.ROUTES' | transloco }}</span>
            </ng-template>
            <div class="tab-content pt-12 pl-24 pr-24">
        <div class="flex flex-row right-tenant justify-between items-center mb-10">
          <div class="flex flex-row flex-wrap justify-start items-center pt-10 pb-10">
            <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'INSTANCE_DETAILS.ROUTES' | transloco}} <span *ngIf="!sftpLoader && initialRouteData?.length > 0">
              ({{filteredRouteData.length}})
            </span></div>
            <div class="ml-16 search-scheduler">
              <app-search-filter *ngIf="initialRouteData?.length > 0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchRoute($event)"></app-search-filter>
            </div>
            <span *ngIf="!sftpLoader && initialRouteData?.length > 0" class="vertical-dash ml-12"></span>
            <button *ngIf="!sftpLoader && initialRouteData?.length > 0" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-24 filter" (click)="filterColumns()">
              <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
              <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
            </button>
          </div>
          <div *ngIf="!sftpLoader" class="flex flex-row justify-end items-center">

            <button *ngIf="permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE]"
            type="button" [ngClass]="[(data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.DEPLOYING || data?.status === DeployStatus.TESTING || data?.status === DeployStatus.OPERATION_INPROGRESS || data?.status === DeployStatus.FAILED || data?.status === DeployStatus.TERMINATED || data?.status === DeployStatus.TERMINATING || data?.status === DeployStatus.INITIALIZING || data?.status === DeployStatus.INITIALIZED || data?.status === DeployStatus.INITIALIZE_FAILED || !sftp) ? 'disabled-btn cursor-default' : 'cursor-pointer', (data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.DEPLOYING || data?.status === DeployStatus.FAILED || data?.status === DeployStatus.TERMINATED || data?.status === DeployStatus.TERMINATING || data?.status === DeployStatus.OPERATION_INPROGRESS || data?.status === DeployStatus.STARTING || data?.status === DeployStatus.STOPPED || data?.status === DeployStatus.STOPPING || data?.status === DeployStatus.START_FAILED || !sftp || !addingStatus) ? 'disable-add-route' : '']" class="flex justify-center items-center tenant-gradient layout-row layout-align-end-start mat-body-2 fw-700" mat-button (click)="createRoutes()"
            [matTooltip]="((data?.status === DeployStatus.TERMINATION_FAILED || data?.status === DeployStatus.DEPLOYING || data?.status === DeployStatus.FAILED || data?.status === DeployStatus.TERMINATED || data?.status === DeployStatus.TERMINATING || !sftp) ? 'TENANT_DETAILS.ADD_ROUTE_DISABLE_BASED_STATUS' : (addingStatus ? '' : 'TENANT_DETAILS.ADD_ROUTE_DISABLE')) | transloco"
              matTooltipClass="form-tooltip above"
              matTooltipPosition="{{Constants.POSITION_ABOVE}}">
              <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
              <span class="mat-subtitle-1 fs-16 fw-700 mb-0">{{'INSTANCE_DETAILS.ADD_ROUTE' | transloco }}</span>
            </button>
          </div>
        </div>
        <div *ngIf="!sftpLoader" class="flex flex-row flex-wrap justify-start items-center pl-2">
          <ng-container *ngIf="direction">
            <div class="flex flex-row items-center pb-10">
              <span class="fw-400">{{ 'TOOLBAR.DIRECTION' | transloco }} </span>
              <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
                {{direction | titlecase}}
                <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(direction)"></mat-icon>
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="status">
            <div class="flex flex-row items-center mr-16 pb-10">
              <span class="fw-400">{{ 'TOOLBAR.STATUS' | transloco }}</span>
              <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
                {{status | titlecase}}
                <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeMenu(status)"></mat-icon>
              </span>
            </div>
          </ng-container>
          <div class="flex flex-row items-center mr-16 pb-10">
            <span *ngIf="direction || status" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
              (click)="resetFilter()">
              {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
          </div>
        </div>
        <div class="flex flex-col border-radius route-table mb-16">
          <app-table (delete)="deleteRoute($event)" (editRouteData)="editRoute($event)" (openSftpForm)="openSshKeyForm($event)" (viewSshKey)="viewSshKeys($event)" [initialDataSource]="filteredRouteData" [searchTerm]="searchTerm" [routeWithExpiration]="routes" [displayColumns]="displayColumns" [dataLoading]="sftpLoader" [showSkeletonLoader]="true" page="sftp" [dataSourceLength]="initialRouteData?.length > 0" pageName="sftp"></app-table>
        </div>
        <ng-template #noRouteFound>
          <div *ngIf="isFailed && initialRouteData?.length === 0" class="rounded-b-lg rounded-t-none no-result text-center py-16 fs-16 fw-500 text-neutral-600">
            <img src="/assets/images/instance-not-found-small.png">
            <div class="mt-8">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
          </div>
        </ng-template>
        </div>
          </mat-tab>
          <mat-tab *ngIf="sftpEncKeyRotation">
            <ng-template mat-tab-label>
              <span class="section-label fw-500">{{'INSTANCE_DETAILS.KEYS' | transloco }}</span>
            </ng-template>
            <div class="tab-content pt-12 pl-24 pr-24">
              <div class="flex flex-row right-tenant justify-between items-center mb-10">
                <div class="flex flex-row flex-wrap justify-start items-center pt-10 pb-10">
                  <div class="mat-subtitle-2 mb-0 fs-24 fw-600">{{'INSTANCE_DETAILS.KEYS' | transloco}} <span *ngIf="!encKeyLoader && initialEncKeys?.length > 0">
                    ({{searchTerm?.length > 0 && searchedResult ? searchedResult.length : encKeys?.length}})
                  </span></div>
                  <div class="ml-16 search-scheduler">
                    <app-search-filter *ngIf="initialEncKeys?.length > 0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchEncKey($event)"></app-search-filter>
                  </div>
                  <span *ngIf="!encKeyLoader && initialEncKeys?.length > 0" class="vertical-dash ml-12"></span>
                  <button *ngIf="!encKeyLoader && initialEncKeys?.length > 0" class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-8 pl-8 pt-6 pb-6 ml-12 filter" (click)="keyFilterColumns()">
                    <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
                    <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
                  </button>
                </div>
                <div *ngIf="!encKeyLoader" class="flex flex-row justify-end items-center">
                  <button *ngIf="permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII] || permissionsMap[PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE]"
                  type="button" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || keyDisabledStatus.includes(data?.status) || INSTANCE_DEPLOYING_STATES.includes(data?.status)) : (keyDisabledStatus.includes(data?.status) || INSTANCE_DEPLOYING_STATES.includes(data?.status))}" class="flex justify-center items-center tenant-gradient layout-row layout-align-end-start mat-body-2 fw-700" mat-button (click)="createEncKey()">
                    <mat-icon svgIcon="add" class="icon-md-2"></mat-icon>
                    <span class="mat-subtitle-1 fs-16 fw-700 mb-0">{{'INSTANCE_DETAILS.ADD_KEY' | transloco }}</span>
                  </button>
                </div>
              </div>
              <div *ngIf="initialEncKeys?.length > 0" class="flex flex-row items-center ml-8 mt-16 mb-16">
                <div class="mr-4 pt-8 pb-4 filtered-items flex items-center fs-16 fw-500" *ngIf="encFilterStartDate && encFilterEndDate">
                    <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                      <span class="date-label mr-4">{{'INSTANCE_DETAILS.EXPIRY_DATE' | transloco}}:</span>
                      {{ datePipe.transform(encFilterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(encFilterEndDate, 'dd MMM yyyy') }}
                      <span class="ml-8">
                      <mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelScheduleDateFilter()"></mat-icon>
                      </span>
                    </span>
                </div>
                <div class="flex flex-row items-center">
                    <span *ngIf="(encFilterStartDate && encFilterEndDate)" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetScheduleFilter()">
                      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
                    </span>
                </div>
              </div>
              <div class="flex flex-col border-radius route-table mb-16">
                <app-table (editKey)="editKeyRoute($event)" [initialDataSource]="encKeys" [searchTerm]="searchTerm" [displayColumns]="encKeyDisplayColumns" [dataLoading]="encKeyLoader" [showSkeletonLoader]="true" page="sftpKey" [sftpEncKeyRotation]="sftpEncKeyRotation" [dataSourceLength]="initialEncKeys?.length > 0" pageName="sftpKey" (searchedResults)="searchedItems($event)"></app-table>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !configurations?.length > 0}">{{'INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco }}</span>
        </ng-template>
        <div class="external-package p-24">
            <mat-tab-group class="release-package-tab" [selectedIndex]="selectedTab" (selectedIndexChange)="tabChange($event)" animationDuration="0ms">
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="section-label fw-500">{{'INSTANCE_DETAILS.APPLY_RELEASE_PACKAGE' | transloco }}</span>
                </ng-template>
                <mat-divider class="neutral-2"></mat-divider>

                @if (isLoadingConfigurations) {
                  <div *ngFor="let item of [1,2,3]" class="instance-card instances-group flex flex-col mb-8 pl-28">
                      <div class="flex flex-row pt-24">
                        <ng-container *ngFor="let item of [1,2,3]">
                          <ngx-skeleton-loader class="loader-line mr-50" count="1" appearance="line"></ngx-skeleton-loader>
                        </ng-container>
                      </div>
                  </div>
                } @else if(availableConfigurations?.length > 0) {
                    <app-instance-apply-configuration  [applyConfigInProgressing]="applyConfigInProgress" [availableConfigurations]="availableConfigurations"
                    (applyConfigClick)="applyConfigClick($event)" [instance]="instance" [isVerifying]="isVerifying" [configs]="configurations" [oldView]="true" (refreshClick)="loadReleaseData()"></app-instance-apply-configuration>
                } @else if(availableConfigLoaded && availableConfigurations?.length === 0) {
                  <div class="flex flex-col items-center mb-20 pt-64 pb-64">
                    <img class="storage-msg-icon" src="/assets/images/home_storage.svg" />
                    <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RELEASE_PACKAGE' | transloco}}</div>
                  </div>
                }
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="section-label fw-500">{{'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
                </ng-template>
                <mat-divider class="neutral-2"></mat-divider>
                <div class="flex flex-row justify-between items-center mb-24 mt-16 w-100-percent">
                  <div class="mat-body-1 fw-700 title m-0">
                    <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
                  </div>
                  <div class="flex flex-row items-center">
                    <button [matMenuTriggerFor]="menu" #filterTrigger class="flex justify-between items-center fw-500 white-bg mr-20">
                      <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
                      <span class="">{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
                    </button>
                    <mat-menu #menu="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
                      <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
                      <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
                      <div class="flex flex-col overflow-class pr-10 filter-menu">
                        <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                          (click)="filterOptionChange(option)" >
                          <mat-icon *ngIf="selectedFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                          <mat-icon *ngIf="selectedFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                            </mat-icon>
                          <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                            {{option.label}}
                          </span>
                        </div>
                      </div>
                    </mat-menu>
                    <app-search-filter placeholder="SEARCH.SEARCH" (changed)="search($event)"></app-search-filter>
                  </div>
                </div>
                <ng-container *ngIf="pageConfigurationStates?.length > 0 && configResultsLoaded; else resultNotAvailable">
                  <div class="tbl tbl-configurations-state w-100-percent pb-48">
                    <div class="tbl-header-row blue mb-8 user-select-none">
                      <div class="tbl-cell col-release-package-name pl-12">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME' | transloco }}</div>
                      <div class="tbl-cell col-version">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION' | transloco }}</div>
                      <div class="tbl-cell col-start-time cursor-pointer" (click)="doSort('applicationStartTime')">
                        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}
                        <ng-container [ngTemplateOutlet]="sortIcon"
                          [ngTemplateOutletContext]="{sort: sort, property: 'applicationStartTime'}"></ng-container>
                      </div>
                      <div class="tbl-cell col-end-time cursor-pointer" (click)="doSort('applicationFinishTime')">
                        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}
                        <ng-container [ngTemplateOutlet]="sortIcon"
                          [ngTemplateOutletContext]="{sort: sort, property: 'applicationFinishTime'}"></ng-container>
                      </div>
                      <div class="tbl-cell col-duration cursor-pointer" (click)="doSort('duration')">
                        {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}
                        <ng-container [ngTemplateOutlet]="sortIcon"
                          [ngTemplateOutletContext]="{sort: sort, property: 'duration'}"></ng-container>
                      </div>
                      <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                    </div>
                    <div class="tbl-body">
                      <div *ngFor="let configurationState of pageConfigurationStates" class="tbl-border mb-8">
                        <div class="tbl-body-row tbl-high-row">
                          <div class="tbl-cell col-release-package-name cursor-pointer pl-12" (click)="configurationNameClick(configurationState)">
                            <span class="underline">{{ configurationsMap[configurationState.configurationId]?.manifest.name }}</span>
                            <div *ngIf="configurationState?.codeResult" class="code-package ml-16" ><mat-icon svgIcon="integration_instructions" [matTooltip]="'INSTANCE_SUMMARY.UPDATE_CONFIGURATION.CODE_PACKAGE_AVAILABLE' | transloco | titlecase"
                              matTooltipPosition="above" matTooltipClass="tooltip-inner above pt-12 pr-16 pb-12 pl-16 fs-16" class="icon-md-1"></mat-icon></div>
                            <button *ngIf="configurationState?.hotfix === true" class="flex flex-row jutsify-center items-center hotfix mt-4 ml-16 h-16 w-55 fw-700 fs-10 cursor-default">{{'BUTTONS.HOTFIX' | transloco}}</button>
                          </div>
                          <div class="tbl-cell col-version">
                            {{ configurationsMap[configurationState.configurationId]?.manifest?.version }}
                          </div>
                          <div class="tbl-cell col-start-time">
                            {{ configurationState.applicationStartTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET }}
                          </div>
                          <div class="tbl-cell col-end-time">
                            {{ configurationState?.applicationFinishTime? (configurationState?.applicationFinishTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                          </div>
                          <div class="tbl-cell col-duration">
                            {{ configurationState.applicationStartTime | duration : configurationState.applicationFinishTime : '-' }}
                          </div>
                          <div class="tbl-cell col-status">
                            <div class="status-tag" [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'verified' : 'fail']">
                              <ng-container [ngSwitch]="configurationState.status">
                                <span *ngSwitchCase="ConfigurationApplicationStatus.SUCCESS">{{ 'CONFIGURATIONS.VIEW_RESULTS.SUCCESS' | transloco }}</span>
                                <span *ngSwitchCase="ConfigurationApplicationStatus.VERIFIED">{{ 'CONFIGURATIONS.VIEW_RESULTS.VERIFIED' | transloco }}</span>
                                <span *ngSwitchDefault>{{ 'CONFIGURATIONS.VIEW_RESULTS.FAILED' | transloco }}</span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <ng-container *ngIf="!pageConfigurationStates?.length > 0 && !configResultsLoaded" >
                  <div *ngFor="let item of [1,2,3]" class="instance-card instances-group flex flex-col mb-8 pl-28">
                      <div class="flex flex-row pt-24">
                        <ng-container *ngFor="let item of [1,2,3]">
                          <ngx-skeleton-loader class="loader-line mr-50" count="1" appearance="line"></ngx-skeleton-loader>
                        </ng-container>
                      </div>
                  </div>
                </ng-container>      
                <ng-template #resultNotAvailable>
                  <div *ngIf="configResultsLoaded" class="flex flex-col items-center mb-20 pt-64 pb-64">
                    <img class="storage-msg-icon" src="/assets/images/home_storage.svg" />
                    <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RESULT_AVAILABLE' | transloco}}</div>
                  </div>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
            </div>
        <!-- <div class="flex flex-row flex-wrap justify-center">
          {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
        </div> -->
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !configurations?.length > 0 || data.deploymentClass === DeploymentClass.A}">{{'INSTANCE_DETAILS.RUN_TEST' | transloco }}</span>
        </ng-template>
        @if ((((data.deploymentClass === DeploymentClass.D || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.RVT_TEST_NONPII])
        || ((data.deploymentClass === DeploymentClass.B || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.RVT_TEST_PII]))) {
          <div class="external-package p-24">
            <ng-container *ngIf="data.deploymentClass === DeploymentClass.A">
              <div class="flex items-center justify-center not-applicable">
                {{'INSTANCE_DETAILS.NOT_APPLICABLE_FOR_CLASS_A' | transloco }}
              </div>
            </ng-container>
            <ng-container *ngIf="data.deploymentClass !== DeploymentClass.A">
              <mat-tab-group class="release-package-tab" [selectedIndex]="selectedRvtTab" (selectedIndexChange)="rvtTabChange($event)" animationDuration="0ms">
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="section-label fw-500">{{'INSTANCE_DETAILS.RVT_PACKAGE' | transloco }}</span>
                  </ng-template>
                  <mat-divider class="neutral-2"></mat-divider>

                  <ng-container *ngIf="configurationsForRvt?.length > 0 && configurationLoaded">
                    <app-instance-execute-rvt [executeRvtInProgressing]="executeRvtInProgress" [availableConfigurationsForRvt]="configurationsForRvt"
                    (executeRvtClick)="executeRvtClick($event)"  [instance]="instance" [configs]="configurations" [isInstance]="true" (refreshClick)="loadReleaseData()"></app-instance-execute-rvt>
                  </ng-container>
                  <ng-container *ngIf="!configurationLoaded">
                    <div class="tbl mt-32">
                      <div class="mb-8 tbl-border" *ngFor="let item of [1,2,3]">
                        <div class="pt-20 pb-14 pl-20 header-loader">
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="configurationLoaded && configurationsForRvt?.length === 0">
                    <div class="flex flex-col items-center mb-20 pt-64 pb-64">
                      <img class="storage-msg-icon" src="/assets/images/home_storage.svg" />
                      <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RELEASE_PACKAGE' | transloco}}</div>
                    </div>
                  </ng-container>
                </mat-tab>
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span class="section-label fw-500">{{'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
                  </ng-template>
                  <mat-divider class="neutral-2"></mat-divider>
                  <div class="flex flex-row justify-between items-center mb-24 mt-16 w-100-percent">
                    <div class="mat-body-1 fw-700 title m-0">
                      <span class="mr-8 mat-headline-6 fw-700 fs-16">{{ 'INSTANCE_DETAILS.VIEW_RESULTS' | transloco }}</span>
                    </div>
                    <div class="flex flex-row items-center">
                      <button [matMenuTriggerFor]="menu1" #filterTrigger class="flex justify-between items-center fw-500 white-bg mr-20">
                        <mat-icon svgIcon="filter_alt" class="mr-8 mb-2"></mat-icon>
                        <span>{{ 'INSTANCE_DETAILS.FILTERS' | transloco }}</span>
                      </button>
                      <mat-menu #menu1="matMenu" class="justify-between items-center pl-24 pr-24 pt-16 pb-16">
                        <span class="mat-subtitle-2 fs-14">{{ 'INSTANCE_DETAILS.FILTER_BY_STATUS' | transloco }}</span>
                        <mat-divider class="neutral-2 mt-8 mb-16"></mat-divider>
                        <div class="flex flex-col overflow-class pr-10 filter-menu">
                          <div *ngFor="let option of filterOptions" class="flex flex-row items-center cursor-pointer w-100-percent p-6"
                            (click)="rvtFilterOptionChange(option)" >
                            <mat-icon *ngIf="selectedRvtFilter.value !== option.value" svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
                            <mat-icon *ngIf="selectedRvtFilter.value === option.value" svgIcon="radio_button_checked" class="radio-icon cursor-pointer">
                              </mat-icon>
                            <span class="mat-body-1 fw-500 ml-6 mr-auto mb-0 primary-fg">
                              {{option.label}}
                            </span>
                          </div>
                        </div>
                      </mat-menu>
                      <app-search-filter placeholder="SEARCH.SEARCH" (changed)="searchRvt($event)"></app-search-filter>
                    </div>
                  </div>
                  <ng-container *ngIf="pageRvtStates?.length > 0 && rvtResultsLoaded">
                    <div class="tbl tbl-configurations-state w-100-percent pb-12">
                      <div class="tbl-header-row blue mb-8 user-select-none">
                        <div class="tbl-cell col-release-package-name pl-12">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.RELEASE_PACKAGE_NAME' | transloco }}</div>
                        <div class="tbl-cell col-version">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.VERSION' | transloco }}</div>
                        <div class="tbl-cell col-start-time cursor-pointer" (click)="doRvtSort('applicationStart')">
                          {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.START_TIME_UTC' | transloco }}
                          <ng-container [ngTemplateOutlet]="sortIcon"
                            [ngTemplateOutletContext]="{sort: rvtSort, property: 'applicationStart'}"></ng-container>
                        </div>
                        <div class="tbl-cell col-end-time cursor-pointer" (click)="doRvtSort('applicationFinish')">
                          {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.END_TIME_UTC' | transloco }}
                          <ng-container [ngTemplateOutlet]="sortIcon"
                            [ngTemplateOutletContext]="{sort: rvtSort, property: 'applicationFinish'}"></ng-container>
                        </div>
                        <div class="tbl-cell col-duration cursor-pointer" (click)="doRvtSort('duration')">
                          {{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.DURATION' | transloco }}
                          <ng-container [ngTemplateOutlet]="sortIcon"
                            [ngTemplateOutletContext]="{sort: rvtSort, property: 'duration'}"></ng-container>
                        </div>
                        <div class="tbl-cell col-status">{{ 'CONFIGURATIONS.VIEW_RESULTS.HEADERS.STATUS' | transloco }}</div>
                      </div>
                      <div class="tbl-body">
                        <div *ngFor="let configurationState of pageRvtStates" class="tbl-border mb-8">
                          <div class="tbl-body-row tbl-high-row">
                            <div class="tbl-cell col-release-package-name cursor-pointer pl-12" (click)="configurationNameClick(configurationState, true)">
                              <span class="underline">{{ configurationsMap[configurationState.configurationId]?.manifest?.name }}</span>
                            </div>
                            <div class="tbl-cell col-version">
                              {{ configurationsMap[configurationState.configurationId]?.manifest?.version }}
                            </div>
                            <div class="tbl-cell col-start-time">
                              {{ configurationState.applicationStartTime ? (configurationState.applicationStartTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                            </div>
                            <div class="tbl-cell col-end-time">
                              {{ configurationState?.applicationFinishTime ? (configurationState?.applicationFinishTime | date: Constants.DATE_TIME_FORMAT: Constants.DATE_TIME_UTC_OFFSET) : '-' }}
                            </div>
                            <div class="tbl-cell col-duration">
                              {{ configurationState.applicationStartTime | duration : configurationState.applicationFinishTime : '-' }}
                            </div>
                            <div class="tbl-cell col-status">
                              <div class="status-tag" [ngClass]="[configurationState.status === ConfigurationApplicationStatus.SUCCESS ? 'success' : configurationState.status === ConfigurationApplicationStatus.VERIFIED ? 'verified' : 'fail']">
                                <ng-container [ngSwitch]="configurationState.status">
                                  <span *ngSwitchCase="ConfigurationApplicationStatus.SUCCESS">{{ 'CONFIGURATIONS.VIEW_RESULTS.SUCCESS' | transloco }}</span>
                                  <span *ngSwitchCase="ConfigurationApplicationStatus.VERIFIED">{{ 'CONFIGURATIONS.VIEW_RESULTS.VERIFIED' | transloco }}</span>
                                  <span *ngSwitchDefault>{{ 'CONFIGURATIONS.VIEW_RESULTS.FAILED' | transloco }}</span>
                                </ng-container>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="p-12">
                      <app-paginator [length]="filteredRvtStates?.length" [pageSizeOptions]="[5, 10, 15]"
                          [pageSize]="rvtPaginatioSize" [pageIndex]="rvtPageIndex" [rangeSize]="3" (page)="rvtPageChanged($event)"></app-paginator>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="!rvtResultsLoaded">
                    <div class="tbl mt-32">
                      <div class="mb-8 tbl-border" *ngFor="let item of [1,2,3]">
                        <div class="pt-20 pb-14 pl-20 header-loader">
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" class="mr-60" appearance="line"></ngx-skeleton-loader>
                          <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="rvtResultsLoaded && pageRvtStates?.length === 0">
                    <div class="flex flex-col items-center mb-20 pt-64 pb-64">
                      <img class="storage-msg-icon" src="/assets/images/home_storage.svg" />
                      <div class="mat-subtitle-1 fw-700 mt-12 mb-16 fs-20">{{'INSTANCE_DETAILS.NO_RESULT_AVAILABLE' | transloco}}</div>
                    </div>
                  </ng-container>
                </mat-tab>
              </mat-tab-group>
            </ng-container>
          </div>
        } @else {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
            <img src="/assets/images/feature_not_available.png">
            <div class="mt-10 feature-not-avaliable">
              {{data.deploymentClass === DeploymentClass.A ? ('FEATURE.PROD_FEATURE_NOT_AVAILABLE' | transloco) : ('FEATURE.FEATURE_NOT_AVAILABLE' | transloco)}}
            </div>
          </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.components?.length > 0}">{{'INSTANCE_DETAILS.COMPONENT_UPDATES' | transloco }}</span>
        </ng-template>
        <div *ngIf="data?.components?.length > 0; else noData" class="settings-log pl-24">
          <div class="flex flex-row justify-between product-header pt-6 pr-30 pb-6 pl-32 bg-color">
            <div>{{'INSTANCE_DETAILS.COMPONENT' | transloco }}</div>
            <div>{{'INSTANCE_DETAILS.CURRENT_VERSION' | transloco }}</div>
          </div>
          <div *ngFor="let element of data?.components | keyvalue" class="flex flex-row justify-between product-rows pt-6 pr-30 pb-6 pl-32 mt-8 mb-8">
            <div>{{element.key}}</div>
            <div>{{element.value}}</div>
          </div>
        </div>
        <ng-template #noData>
          <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
            <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.localConfigStatus}">{{'TENANT_DETAILS.LOCAL_CONFIG' | transloco }}</span>
        </ng-template>
        <div *ngIf="data; else noLocalConfigData" class="settings-log pl-24">
          <div class="label-text flex mt-24 fw-700 fs-16">
            <div class="config-key">{{ 'TENANT_DETAILS.LOCAL_CONFIG' | transloco }}</div>
            <div>:&nbsp;</div>
            <div *ngIf="data; else loader" class="val fw-400 fs-16 flex flex-row" [ngClass]="data?.localConfigStatus">
              <mat-icon *ngIf="data?.localConfigStatus" [svgIcon]="data?.localConfigStatus === 'applied' ? 'check_circle' : 'error'" class="icon-sm mr-6 mt-2"></mat-icon>
              {{data?.localConfigStatus ? (data?.localConfigStatus | titlecase) : '--'}}
            </div>
          </div>
          <ng-template #loader>
            <div class="pl-6 skeleton-loader">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          </ng-template>
          <div class="label-text flex mt-24 fw-700 fs-16">
            <div class="config-key">{{ 'TENANT_DETAILS.EXECUTED_ON' | transloco }}</div>
            <div>:&nbsp;</div>
            <div *ngIf="data; else loader" class="val fw-400 fs-16">{{data?.localConfigExecutedAt ? (data?.localConfigExecutedAt | date: 'dd MMM yyyy, HH:mm') + ' UTC' : '--'}}</div>
          </div>
          <ng-template #loader>
            <div class="pl-6 skeleton-loader">
              <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          </ng-template>
        </div>
        <ng-template #noLocalConfigData>
          <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
            <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
          </div>
        </ng-template>
      </mat-tab>
      <!-- <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !taskInfo?.sourceSolutionVersion}">{{'INSTANCE_DETAILS.UPDATES' | transloco }}</span>
        </ng-template>
        <div class="mat-subtitle-2 fw-700 mt-8 mb-10">{{'INSTANCE_DETAILS.LIST_OF_RELEASE_AVAILABLE_TO_UPGRADE' | transloco }}</div>
        <div class="flex flex-row justify-between product-header pt-6 pr-30 pb-6 pl-32">
          <div>{{'INSTANCE_DETAILS.BUILD_NUMBER' | transloco }}</div>
          <div>{{'INSTANCE_DETAILS.RELEASE_VERSION' | transloco }}</div>
        </div>
        <ng-container *ngIf="taskInfo && taskInfo?.version && taskInfo?.releaseVersion">
          <div class="flex flex-row justify-between mt-6">
            <div class="pl-32">{{taskInfo?.version}}</div>
            <div class="pr-96 cursor-pointer" (click)="gotoChangeTasks(taskInfo)">{{taskInfo?.releaseVersion}}</div>
          </div>
        </ng-container>
      </mat-tab> -->
      <!-- <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.details?.temenosProducts}">{{'INSTANCE_DETAILS.PRODUCTS' | transloco }}</span>
        </ng-template>
        <div class="flex flex-row justify-between product-header pt-6 pr-30 pb-6 pl-32">
          <div>{{'INSTANCE_DETAILS.PRODUCT' | transloco }}</div>
          <div>{{'INSTANCE_DETAILS.VERSION' | transloco }}</div>
        </div>
        <div *ngFor="let product of data?.details?.temenosProducts | keyvalue" class="flex flex-row justify-between product-rows pt-6 pr-30 pb-6 pl-32 mt-8 mb-8">
          <div>{{product.key}}</div>
          <div>{{product.value}}</div>
        </div>
      </mat-tab> -->
      <!-- <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.details?.dynatraceURL}">{{'INSTANCE_DETAILS.MONITORING' | transloco }}</span>
        </ng-template>
        <div class="mat-subtitle-2 fw-700 mt-8">{{'INSTANCE_DETAILS.MONITORING_DETAILS' | transloco }}</div>
        <div class="flex flex-row flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.DYNATRACE_URL' | transloco}}</div>
            <div class="overview-values fw-500 edit_hover_class"><span class="pr-16">:</span>{{data?.details?.dynatraceURL ? data?.details?.dynatraceURL : '-'}}
              <mat-icon *ngIf="data?.details?.dynatraceURL" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.details?.dynatraceURL)"></mat-icon>
            </div>
          </div>
        </div>
      </mat-tab> -->
      <!-- <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.details?.adoPipeline}">{{'INSTANCE_DETAILS.PIPELINE' | transloco }}</span>
        </ng-template>
        <div class="flex flex-col flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.ADO_PIPELINE_NAME' | transloco}}</div>
            <div class="overview-values fw-500 edit_hover_class"><span class="pr-16">:</span>{{data?.details?.adoPipeline ? data?.details?.adoPipeline : '-'}}
              <mat-icon *ngIf="data?.details?.adoPipeline" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.details?.adoPipeline)"></mat-icon>
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.ADO_VARIABLE_GROUP_NAME' | transloco}}</div>
            <div class="overview-values fw-500 edit_hover_class"><span class="pr-16">:</span>{{data?.details?.adoVariableGroup ? data?.details?.adoVariableGroup : '-'}}
              <mat-icon *ngIf="data?.details?.adoVariableGroup" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.details?.adoVariableGroup)"></mat-icon>
            </div>
          </div>
        </div>
        <div class="flex flex-col flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.EXTERNAL_ORIGINATION' | transloco}}</div>
            <div class="overview-values fw-500 edit_hover_class"><span class="pr-16">:</span>{{data?.details?.externalOrigination ? data?.details?.externalOrigination : '-'}}
              <mat-icon *ngIf="data?.details?.externalOrigination" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.details?.externalOrigination)"></mat-icon>
            </div>
          </div>
        </div>
      </mat-tab>             -->
      <!-- <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.details?.aksVersion}">{{'INSTANCE_DETAILS.INFRA' | transloco }}</span>
        </ng-template>
        <div class="flex flex-row flex-wrap gap-30">
          <div class="metrics pt-12 pb-12 flex flex-row justify-start items-center">
            <div class="metrics-label mat-body-2 fw-400">{{ 'INSTANCE_DETAILS.AKS_VERSION' | transloco}}</div>
            <div class="overview-values fw-500 edit_hover_class"><span class="pr-16">:</span>{{data?.details?.aksVersion ? data?.details?.aksVersion : '-'}}
              <mat-icon *ngIf="data?.details?.aksVersion" class="h-18 w-18 mr-6" [ngClass]="[copy ? 'copied': 'copy']" [svgIcon]="copy ? 'check' : 'content_copy'" (click)="onCopyId(data?.details?.aksVersion)"></mat-icon>
            </div>
          </div>
        </div>
      </mat-tab> -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !logData?.length > 0}" >{{'TENANT_DETAILS.ACTIVITY' | transloco }}</span>
        </ng-template>
        <div class="flex flex-col mt--16">
          <div class="flex flex-row justify-end items-center ml-8 pb-8">
            <div class="flex flex-row items-center">
              <div class="mr-4 pt-8 pb-8 pl-20 pr-20 date-tag flex items-center fs-16 fw-500" *ngIf="selectedActions?.length > 0">
                <span class="pr-4 fs-12">Action:</span>
                <div *ngFor="let option of selectedActions; let i = index">
                  <span *ngIf="i < 3">{{option | titlecase}}</span><span class="pr-4" *ngIf="(i < 2) && (i < selectedActions?.length - 1)">,</span>
                </div>
                <span *ngIf="selectedActions?.length > 3">...</span><span class="more-text" *ngIf="selectedActions?.length > 3">+{{selectedActions?.length - 3}}more</span>
                <span class="ml-8"><mat-icon svgIcon="close" class="cursor-pointer icon-sm pl-2" (click)="cancelActionFilter()"></mat-icon></span>
              </div>
              <div class="mr-4 pt-8 pb-8 pl-20 pr-20 date-tag flex items-center fs-16 fw-500" *ngIf="deploymentLog && filterStartDate && filterEndDate">{{ datePipe.transform(filterStartDate, 'dd MMM yyyy') }} - {{ datePipe.transform(filterEndDate, 'dd MMM yyyy') }}
                <span class="ml-8"><mat-icon svgIcon="close" class="cursor-pointer icon-sm" (click)="cancelFilter()"></mat-icon></span>
              </div>
              <button class="flex justify-center items-center context-menu-icon-filter height menu-btn pr-16" (click)="dateFilter()">
                <mat-icon svgIcon="filter_alt" class="mr-4"></mat-icon>
                <span class="fw-500 filters">{{'INSTANCE_DETAILS.FILTER' | transloco}}</span>
              </button>
            </div>
          </div>
          <mat-divider class="mb-12 title-divider"></mat-divider>
          <div class="flex flex-col endpoints deploymentLogs" [ngClass]="{'disabled': showLoader}">
            <div *ngIf="deploymentLogData?.length > 0 && dataSourceLog?.filteredData?.length > 0; else noLogFound" class="flex flex-col border-radius">
              <table mat-table [dataSource]="dataSourceLog" matSort (matSortChange)="sortData($event)" multiTemplateDataRows class="mat-elevation-z8">
                <ng-container matColumnDef="menu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 expand-column"></th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}">
                    <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8 cursor-pointer expand-column"
                      [matMenuTriggerFor]="logSubmenu">
                      <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class" (click)="onArrowClick(data)"></mat-icon>
                    </button>
                    <mat-menu #logSubmenu [xPosition]="'before'" class="context-menu-dropdown">
                      <div *ngIf="arrowClicked" class="flex flex-col">
                      </div>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.ACTION' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16 flex flex-row justify-start items-center">
                    {{data?.action | titlecase}} <span *ngIf="data?.location" class="location-type ml-8 pl-8 pr-8 pb-2">{{data?.location}}</span>
                    <mat-icon *ngIf="data.shutdown" svgIcon="timer" matTooltipClass="below my-tooltip" matTooltipPosition="below" [matTooltip]="('INSTANCE_DETAILS.SHUTDOWN_HOURS' | transloco | titlecase) + data.shutdown" class="timer-color icon-md ml-16 mt-2"></mat-icon>
                  </td>
                </ng-container>
                <ng-container matColumnDef="startTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase}}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.startTime ? (data?.startTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                </ng-container>
                <ng-container matColumnDef="finishTime">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.finishTime ? (data?.finishTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                </ng-container>
                <ng-container matColumnDef="duration">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.TOTAL_DURATION' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data"><span class="p-2 p-8 fw-400 fs-16 duration">{{data?.startTime | timeDuration : data?.finishTime : '-'}}</span></td>
                </ng-container>
                <ng-container matColumnDef="success">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.SUCCESS' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">
                    <span class="p-2 p-8 success">{{countSuccess(data)}}</span></td>
                </ng-container>
                <ng-container matColumnDef="failure">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.FAILURE' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                    <span class="p-2 p-8 failure">{{countFailure(data)}}</span></td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STATUS' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                    <span class="p-6" [ngClass]="data?.status">{{data?.status ? (data?.status | titlecase) : '-'}}</span></td>
                </ng-container>
                <ng-container matColumnDef="initiatedBy">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.INITIATED_BY' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                    <span class="p-6" [ngClass]="data?.initiatedBy">{{data?.initiatedBy ? (data?.initiatedBy) : '-'}}</span></td>
                </ng-container>
                <ng-container matColumnDef="jobId">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.JOB_ID' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                    <ng-container *ngIf="data?.jobId && data.jobId !== '-'; else emptyJobId">
                        <span class="p-6 fs-16 fw-400 job-id" [ngClass]="data?.jobId" (click)="jobId(data.jobId)">{{data?.jobId}}</span>
                    </ng-container>
                  <ng-template #emptyJobId>
                    <span class="p-6" [ngClass]="data?.jobId">-</span>
                 </ng-template>
                 </td>
                </ng-container>
                <ng-container hidden matColumnDef="arrow">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16"></td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="logColumns.length" [ngClass]="{'inner-table': element === expandedElement}" class="inner-table">
                    <div class="example-element-detail flex-col" *ngIf="element === expandedElement" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                      <ng-container *ngIf="dataSourceInnerLog?.length > 0; else noInnerLogFound">
                      <table mat-table [dataSource]="dataSourceInnerLog" multiTemplateDataRows class="mat-elevation logs">
                        <ng-container matColumnDef="componentName">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COMPONENT_NAME' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">
                            {{data?.name}}<span *ngIf="data?.componentType" class="comp-type ml-8 pl-8 pr-8 pb-2">{{data?.componentType}}</span></td>
                        </ng-container>
                        <ng-container matColumnDef="version">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16" >{{data?.version | titlecase}} </td>
                        </ng-container>
                        <ng-container matColumnDef="startTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.start ? (data?.start | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="endTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.end ? (data?.end | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="duration">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.DURATION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">
                            <span [ngClass]="addClassDuration((data?.start | timeDuration : data?.end),data?.status)" class="p-8">{{data?.start | timeDuration : data?.end : '-'}}</span></td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STATUS' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="flex justify-center items-center status">
                            <ng-container *ngIf="data?.status === 'inprogress'; else otherStatus">
                              <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
                            </ng-container>
                            <ng-template #otherStatus>
                              <mat-icon [svgIcon]="data?.status === 'success' ? 'done' : 'close'" [ngClass]="data?.status === 'success' ? 'sucess-circle icon-md p-2' : 'failed-circle icon-md p-2'"></mat-icon>
                            </ng-template>
                        </ng-container>
                        <ng-container hidden matColumnDef="arrow">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16"></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerLogColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerLogColumns;"></tr>
                        </table>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="logColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: logColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
              </table>
            </div>
            <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
              <mat-spinner diameter="24"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
            </mat-card>
            <ng-template #noLogFound>
            <div *ngIf="isLogFailed || (filterStartDate && filterEndDate && filteredDeploymentLog?.length === 0)" class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
              <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
            </div>
            </ng-template>

            <mat-card *ngIf="showActivityLoader" class="flex spinner-container spinner">
              <mat-spinner diameter="24"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
            </mat-card>
            <ng-template #noInnerLogFound>
              <div>
              <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation logs">
                <ng-container matColumnDef="componentName">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COMPONENT_NAME' | transloco | uppercase }} </th>
                </ng-container>
                <ng-container matColumnDef="version">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.VERSION' | transloco | uppercase }} </th>
                </ng-container>
                <ng-container matColumnDef="startTime">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                </ng-container>
                <ng-container matColumnDef="endTime">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                </ng-container>
                <ng-container matColumnDef="duration">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.DURATION' | transloco | uppercase }} </th>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STATUS' | transloco | uppercase }} </th>
                </ng-container>
                <ng-container hidden matColumnDef="arrow">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="innerLogColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: innerLogColumns;"></tr>
              </table>
              </div>
              <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
              </div>
            </ng-template>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !efTestResults?.length > 0 && !sanityTestResults?.length > 0 }" >{{'TENANT_DETAILS.TESTING' | transloco }}</span>
        </ng-template>
        @if (isAWS) {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-50 fs-16">
            <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
          </div>
        } @else if ((data.deploymentClass === DeploymentClass.D && featuresMap[FeatureKeys.EF_TEST_NONPII])
          || (featuresMap[FeatureKeys.SANITY_TEST_NONPII] || featuresMap[FeatureKeys.SANITY_TEST_PII] || featuresMap[FeatureKeys.SANITY_TEST_LIVE])) {
          <div class="test-results">
            <div class="flex flex-row tabs">
              <div *ngIf="featuresMap[FeatureKeys.SANITY_TEST_NONPII] || featuresMap[FeatureKeys.SANITY_TEST_PII] || featuresMap[FeatureKeys.SANITY_TEST_LIVE]" class="test-tabs mat-subtitle-1 fs-20 mr-32"  [ngClass]="{'active fw-600': sanityTest}" (click)="testTabs('sanity')">{{'TEST_RESULTS.SANITY_TEST' | transloco}}</div>
              <div *ngIf="data.deploymentClass === DeploymentClass.D && featuresMap[FeatureKeys.EF_TEST_NONPII]" class="test-tabs mat-subtitle-1 fs-20" [ngClass]="{'disabled': data.deploymentClass !== DeploymentClass.D, 'active fw-600': efTest}" (click)="testTabs('efTest')">{{'TEST_RESULTS.EF_TEST' | transloco}}</div>
            </div>
            <ng-container *ngIf="sanityTest">
              <div *ngIf="((data.deploymentClass === DeploymentClass.D || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.SANITY_TEST_NONPII]) || (data.deploymentClass === DeploymentClass.B && featuresMap[FeatureKeys.SANITY_TEST_PII]) || (data.deploymentClass === DeploymentClass.A && featuresMap[FeatureKeys.SANITY_TEST_LIVE])" class="flex flex-row justify-end mt-24">
                <button class="flex justify-center items-center excecute-test fw-600 h-32 p-10 mat-body-2" [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || isSanityTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : isSanityTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="(isSanityTestInprogress && EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? ('TEST_RESULTS.SANITY_TEST_INPROGRESS' | transloco) : ''" (click)="(isSanityTestInprogress || !EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? '' : excecuteSanityTest()">
                  {{'TEST_RESULTS.EXCECUTE_TEST' | transloco}}
                </button>
              </div>
              <div class="flex flex-col deploymentLogs mt-24">
                <div *ngIf="sanityTestResults?.length > 0; else noSanityTestResultsFound" class="flex flex-col border-radius">
                  <table mat-table [dataSource]="dataSourceSanityTestResults" matSort (matSortChange)="applyColumnSort($event)" multiTemplateDataRows class="mat-elevation-z8">
                    <ng-container matColumnDef="testStartTime">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.START_DATE' | transloco | uppercase}}</th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.testStartTime ? (data?.testStartTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="testFinishTime">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.END_DATE' | transloco | uppercase }}</th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.testFinishTime ? (data?.testFinishTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.DURATION' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data"><span class="fw-400 fs-16">{{data?.testStartTime | timeDuration : data?.testFinishTime : '-'}}</span></td>
                    </ng-container>
                    <ng-container matColumnDef="initiatedBy">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'TEST_RESULTS.INITIATED_BY' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                        <span [ngClass]="data?.initiatedBy">{{data?.initiatedBy ? (data?.initiatedBy | titlecase) : '-'}}</span></td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 status"> {{'TEST_RESULTS.STATUS' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" class="flex items-center status fs-16">

                        <span *ngIf="data?.status" class="flex pt-6 pb-6 pl-10 pr-10" [ngClass]="data?.status">
                          <ng-container *ngIf="data?.status === 'inprogress'; else otherStatus">
                            <mat-spinner diameter="20" mode="indeterminate" class="test-spinner"></mat-spinner>
                          </ng-container>
                          <ng-template #otherStatus>
                            <mat-icon [svgIcon]="data?.status === 'success' ? 'check_circle' : 'priority_high'" [ngClass]="data?.status === 'success' ? 'sucess-circle icon-md p-2' : 'failed-circle icon-md p-2'"></mat-icon>
                          </ng-template>
                          {{data?.status === 'inprogress'? ('TEST_RESULTS.IN_PROGRESS' | transloco):
                          data?.status === 'success'? ('TEST_RESULTS.SUCCESS' | transloco):
                          'TEST_RESULTS.FAILED' | transloco }}
                        </span>
                    </ng-container>
                    <ng-container matColumnDef="testResultsPath">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"> {{'TEST_RESULTS.RESULT' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="text-right result cell-data fw-400 fs-16">
                        <span *ngIf="data?.testResultsPath; else downloadNotAvailalable" class="pl-20">
                        <mat-icon svgIcon="file_download" class="flex justify-end cursor-pointer" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status === 'inprogress') : data?.status === 'inprogress'}" (click)="downloadResult(data)"></mat-icon>
                        <mat-icon svgIcon="visibility" class="flex justify-end cursor-pointer ml-16" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status === 'inprogress') : data?.status === 'inprogress'}" (click)="viewTestResults(data, data.testResultsPath, 'SanityResults' )"></mat-icon>
                        </span>
                        <ng-template #downloadNotAvailalable>
                          <span class="pl-30">-</span>
                        </ng-template>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="testResultColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: testResultColumns;"></tr>
                  </table>
                </div>
                <app-paginator class="p-24" [length]="sanityTestResults?.length" [pageSizeOptions]="[10, 15, 20]"
                  [pageSize]="sanityPaginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="sanityResultsChanged($event)"></app-paginator>
                <ng-template #noSanityTestResultsFound>
                <div *ngIf="dataLoaded" class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                  <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                </div>
              </ng-template>
              </div>
            </ng-container>
            <ng-container *ngIf="efTest && data.deploymentClass === DeploymentClass.D && featuresMap[FeatureKeys.EF_TEST_NONPII]">
              <div *ngIf="data.deploymentClass === DeploymentClass.D" class="flex flex-row justify-end mt-24 mb-24">
                <button class="flex justify-center items-center excecute-test fw-600 h-32 p-10 mat-body-2" [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || isEFTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : isEFTestInprogress || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="(isEFTestInprogress && EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? ('TEST_RESULTS.EF_TEST_INPROGRESS' | transloco) : ''" (click)="(isEFTestInprogress || !EXCECUTETEST_ENABLE_STATES.includes(data?.status)) ? '' : excecuteEFTest()">
                  {{'TEST_RESULTS.EXCECUTE_TEST' | transloco}}
                </button>
              </div>
              <div *ngIf="data.deploymentClass === DeploymentClass.D" class="flex flex-col deploymentLogs">
                <div *ngIf="efTestResults?.length > 0; else noEFTestResultsFound" class="flex flex-col border-radius">
                  <table mat-table [dataSource]="dataSourceEFTestResults" matSort (matSortChange)="applyColumnSort($event)" multiTemplateDataRows class="mat-elevation-z8">
                    <ng-container matColumnDef="testStartTime">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.START_DATE' | transloco | uppercase}}</th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.testStartTime ? (data?.testStartTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="testFinishTime">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.END_DATE' | transloco | uppercase }}</th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.testFinishTime ? (data?.testFinishTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'TEST_RESULTS.DURATION' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" class="route-id cell-data"><span class="fw-400 fs-16">{{data?.testStartTime | timeDuration : data?.testFinishTime : '-'}}</span></td>
                    </ng-container>
                    <ng-container matColumnDef="initiatedBy">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'TEST_RESULTS.INITIATED_BY' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="route-id cell-data fw-400 fs-16">
                        <span [ngClass]="data?.initiatedBy">{{data?.initiatedBy ? (data?.initiatedBy | titlecase) : '-'}}</span></td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 status"> {{'TEST_RESULTS.STATUS' | transloco | uppercase }} </th>
                      <td mat-cell *matCellDef="let data" class="flex items-center status fs-16">

                        <span *ngIf="data?.status" class="flex pt-6 pb-6 pl-10 pr-10" [ngClass]="data?.status">
                          <ng-container *ngIf="data?.status === 'inprogress'; else otherStatus">
                            <mat-spinner diameter="20" mode="indeterminate" class="test-spinner"></mat-spinner>
                          </ng-container>
                          <ng-template #otherStatus>
                            <mat-icon [svgIcon]="data?.status === 'success' ? 'check_circle' : 'priority_high'" [ngClass]="data?.status === 'success' ? 'sucess-circle icon-md p-2' : 'failed-circle icon-md p-2'"></mat-icon>
                          </ng-template>
                          {{data?.status === 'inprogress'? ('TEST_RESULTS.IN_PROGRESS' | transloco):
                          data?.status === 'success'? ('TEST_RESULTS.SUCCESS' | transloco):
                          'TEST_RESULTS.FAILED' | transloco }}
                        </span>
                    </ng-container>
                    <ng-container matColumnDef="testResultsPath">
                      <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"> {{'TEST_RESULTS.RESULT' | transloco | uppercase }}</th>
                      <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}" class="text-center result cell-data fw-400 fs-16">
                        <span *ngIf="data?.testResultsPath; else downloadNotAvailalable" class="pl-20 flex justify-end">
                          <mat-icon svgIcon="file_download" class="flex justify-end cursor-pointer" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status === 'inprogress') : data?.status === 'inprogress'}" (click)="downloadResult(data)"></mat-icon>
                          <mat-icon svgIcon="visibility" class="flex justify-end cursor-pointer ml-16" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status === 'inprogress') : data?.status === 'inprogress'}" (click)="viewTestResults(data, data.testResultsPath, 'EFTestResults' )"></mat-icon>

                        </span>
                        <ng-template #downloadNotAvailalable>
                          <span class="pl-30">-</span>
                        </ng-template>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="testResultColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: testResultColumns;"></tr>
                  </table>
                </div>
                <app-paginator class="p-24" [length]="efTestResults?.length" [pageSizeOptions]="[10, 15, 20]"
                  [pageSize]="EFPaginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="EFResultsChanged($event)"></app-paginator>
                <ng-template #noEFTestResultsFound>
                  <div *ngIf="dataLoaded" class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                    <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                  </div>
              </ng-template>
              </div>
            </ng-container>
          </div>
        } @else {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
            <img src="/assets/images/feature_not_available.png">
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
          </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': !data?.cob}">{{'TENANT_DETAILS.COB' | transloco }}</span>
        </ng-template>
        @if (isAWS) {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-50 fs-16">
            <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
          </div>
        } @else if ((((data.deploymentClass === DeploymentClass.D || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_NONPII])
        || ((data.deploymentClass === DeploymentClass.B || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_PII])
        || ((data.deploymentClass === DeploymentClass.A || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_LIVE]))) {
        <div *ngIf="(data?.cob && data?.cob?.status !== DeployStatus.DELETED); else noCob" [ngClass]="{'disabled': showLoader}">
          <div>
            <div><h3 class="mt-0 fs-18">{{'TENANT_DETAILS.COB_DETAILS' | transloco }}</h3></div>
            <div *ngIf="data?.cob?.status === 'failed' || data?.cob?.status === 'inprogress'" class="mt-12 mb-16 pt-8 pb-8 pl-12 fw-500 flex items-center" [ngClass]="{'cob-inprogress': data?.cob?.status === 'inprogress', 'cob-failed': data?.cob?.status === 'failed'}">
              <mat-icon *ngIf="data?.cob?.status === 'failed'" svgIcon="report_problem" class="icon-md mr-8"></mat-icon>
              <mat-spinner class="mr-8" *ngIf="data?.cob?.status === 'inprogress'" diameter="20"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
              {{ data?.cob?.status === 'failed' ? ('INSTANCE_DETAILS.COB_CONFIG_FAILED' | transloco) : ('INSTANCE_DETAILS.COB_CONFIG_INPROGRESS' | transloco)}}
            </div>
          </div>
          <div class="settings-log pl-24">
            <div class="flex flex-row justify-between">
              <div class="label-text flex fw-600 fs-16">
                <div class="cob-key-ado">{{ 'INSTANCE_DETAILS.ADO_PIPELINE_URL' | transloco }}</div>
                <div>:</div>
                <div *ngIf="data?.cob?.adoPipelineUrl; else noUrl">
                  <a href="javascript:void(0);" (click)="openCobPipelineUrl(data?.cob?.adoPipelineUrl)" class="no-underline-cob">{{'GROUPS.CLICK_HERE' | transloco}}</a>
                </div>
                <ng-template #noUrl>
                  <div class="ml-6">--</div>
                </ng-template>
              </div>
              <div class="flex gap-6">
                <!-- <button *ngIf="(data?.cob?.status === DeployStatus.FAILED || data?.cob?.status != DeployStatus.CONFIGURED)" class="flex justify-center items-center tenant-gradient mat-subtitle-2 view-btn" mat-button type="button" (click)="onEditClick(data?.cob?.inputs)">
                  {{'SOLUTIONS.RECONFIGURE' | transloco }}
                </button> -->
                <!-- <button *ngIf="data?.cob?.status != DeployStatus.CONFIGURED" class="flex justify-center items-center tenant-gradient mat-subtitle-2 ml-20 view-btn" mat-button type="button" (click)="viewCobDetails()">
                  {{'INSTANCE_DETAILS.VIEW_DETAILS' | transloco }}
                </button> -->

                <button (click)="viewCobDetails()" *ngIf="data?.cob?.status === DeployStatus.CONFIGURED"
                  class="flex justify-center items-center h-32 cob-button" color="view">
                  <div class="flex flex-row justify-start items-center">
                    <mat-icon svgIcon="remove_red_eye" class="icon-md mr-10"></mat-icon>
                    <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{'BUTTONS.VIEW' | transloco }}</div>
                  </div>
                </button>

                <button (click)="onEditClick(data?.cob?.inputs, 'update')" *ngIf="data?.cob?.status === DeployStatus.CONFIGURED"
                  class="flex justify-center items-center h-32 primary-bg" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (instance?.status | isIn: INSTANCE_DEPLOYING_STATES)) : (instance?.status | isIn: INSTANCE_DEPLOYING_STATES)">
                  <div class="flex flex-row justify-start items-center white-fg">
                    <mat-icon svgIcon="edit" class="icon-md mr-10"></mat-icon>
                    <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{'BUTTONS.EDIT' | transloco }}</div>
                  </div>
                </button>

                <button (click)="deleteCobDetails()" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || instance?.status | isIn: INSTANCE_DEPLOYING_STATES) : instance?.status | isIn: INSTANCE_DEPLOYING_STATES}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (instance?.status | isIn: INSTANCE_DEPLOYING_STATES)) : (instance?.status | isIn: INSTANCE_DEPLOYING_STATES)"
                  *ngIf="(data?.cob?.status === DeployStatus.FAILED || data?.cob?.status === DeployStatus.CONFIGURED || data?.cob?.status === DeployStatus.DELETION_FAILED)"
                  class="flex justify-center items-center h-32 cob-button" color="red">
                  <div class="flex flex-row justify-start items-center white-fg">
                    <mat-icon svgIcon="delete" class="icon-md mr-10"></mat-icon>
                    <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{'BUTTONS.DELETE' | transloco }}</div>
                  </div>
                </button>

                <div class="flex flex-row" *ngIf="(data?.cob?.status === DeployStatus.DELETING)">
                  <mat-spinner diameter="20"
                    class="flex flex-row mr-12"
                    color="primary"
                    mode="indeterminate">
                   </mat-spinner>
                  {{'INSTANCE_DETAILS.COB_DELETING_MSG' | transloco}}
                </div>

               <button (click)="onEditClick(data?.cob?.inputs, 'reconfigure')"
                  *ngIf="(data?.cob?.status === DeployStatus.FAILED)" [ngClass]="{'disabled': instance?.status | isIn: INSTANCE_DEPLOYING_STATES}" [disabled]="(instance?.status | isIn: INSTANCE_DEPLOYING_STATES)"
                  class="flex justify-center items-center tenant-gradient h-32 cob-button">
                  <div class="flex flex-row justify-start items-center primary-fg">
                    <div class="mat-subtitle-2 mb-0 fw-600 fs-14">{{'SOLUTIONS.RECONFIGURE' | transloco }}</div>
                  </div>
                </button>

              </div>
              <!-- <button *ngIf="data?.cob?.inputs" [ngClass]="{'disabled': !isCobLoaded}" class="flex items-center btn-link mat-headline-6 fs-16 mb-0 fw-700" (click)="onEditClick(data?.cob?.inputs)">
                <mat-icon svgIcon="edit" class="mr-12"></mat-icon>
                {{'SOLUTIONS.EDIT' | transloco }}
              </button> -->
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            <div class="flex flex-row">
              <div class="label-text flex mt-24 fw-500 fs-16 vertical-indicator-cob">
                <div class="cob-key">{{ 'TEST_RESULTS.SCHEDULE1' | transloco }}</div>
                <div>:</div>
                <div *ngIf="data; else loader" class="fw-500 fs-16 schedule-color pl-4">{{sch1 ? sch1 : '--'}}</div>
              </div>
              <div class="label-text flex mt-24 fw-500 fs-16">
                <div class="cob-key">{{ 'TEST_RESULTS.SCHEDULE2' | transloco }}</div>
                <div>:</div>
                <div *ngIf="data; else loader" class="fw-500 fs-16 schedule-color pl-4">{{sch2 ? sch2 : '--'}}</div>
              </div>
            </div>
            <ng-template #loader>
              <div class="pl-6 skeleton-loader">
                <ngx-skeleton-loader count="1" appearance="line"></ngx-skeleton-loader>
              </div>
            </ng-template>
            </div>
          </div>
        <div class="flex flex-col mt-20">
          <div class="flex flex-col endpoints deploymentLogs">
            <div *ngIf="cobTable?.length > 0" class="flex flex-col border-radius">
              <table mat-table [dataSource]="dataSourceCob" matSort (matSortChange)="sortCobData($event)" multiTemplateDataRows class="mat-elevation-z8">
                <ng-container matColumnDef="menu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 expand-column"></th>
                  <td mat-cell *matCellDef="let data" [ngClass]="{'selected': data.arrowClick}">
                    <button class="flex justify-center items-center context-menu-icon pl-6 pr-6 pt-8 cursor-pointer expand-column"
                      [matMenuTriggerFor]="cobSubmenu">
                      <mat-icon [svgIcon]="!data.arrowClick ? 'chevron_right' : 'expand_more'" class="relative-class" (click)="onCobArrowClick(data)"></mat-icon>
                    </button>
                    <mat-menu #cobSubmenu [xPosition]="'before'" class="context-menu-dropdown">
                      <div *ngIf="arrowClicked" class="flex flex-col">
                      </div>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COB_BUILD_ID' | transloco | uppercase }} </th>
                  <td mat-cell *matCellDef="let data" class="route-id id-width cell-data fw-400 fs-16 edit_hover_class">
                    <a *ngIf="data?.cobRunId" class="items-center fw-400 fs-14 ml-10 no-underline-cob" href="javascript:void(0)" [ngClass]="{'text-underline' : adoPipelineUrl && adoProjectName}" (click)="(adoPipelineUrl && adoProjectName) ? onClickLink(data?.cobRunId) : ''">{{data?.cobRunId | titlecase}}</a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.COB_DATE' | transloco | uppercase}}</th>
                  <td mat-cell *matCellDef="let data" class="route-id date-width cell-data fw-400 fs-16">{{data?.cobDate ? (data?.cobDate !== '--' ? (data?.cobDate | date: 'dd MMM yyyy') : data?.cobDate) : '-'}}</td>
                </ng-container>
                <ng-container matColumnDef="timeTaken">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.TOTAL_TIME_TAKEN' | transloco | uppercase }}</th>
                  <td mat-cell *matCellDef="let data" class="route-id time-width cell-data fw-400 fs-16">{{data?.totalTime | titlecase}}</td>
                </ng-container>
                <ng-container matColumnDef="completionMode">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"></th>
                  <td mat-cell *matCellDef="let data" class="text-right justify-center result cell-data fw-400 fs-16" [ngClass]="{'completion-width' : data?.completionMode !== 'manual'}">
                    <span *ngIf="data?.completionMode === 'manual'" class="flex items-center completion-mode fs-14 fw-400 pt-8 pr-16 pb-8 pl-16 mr-16">
                      {{'INSTANCE_DETAILS.MANUAL' | transloco }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" class="status-width route-id cell-data fw-400 fs-16">
                    <div class="flex flex-row justify-center items-center service-version width-status pt-8 pr-16 pb-8 pl-16 mr-24" [ngClass]="data?.status === 'completed' ? 'success-cob' : data?.status === 'started' ? 'started' : data?.status === 'not started' ? 'not-started' : 'failed-cob'">
                      <mat-icon *ngIf="data?.status !== 'not started'" class="icon-md p-2 mr-4" [svgIcon]="data?.status === 'failed' ? 'error' : data?.status === 'completed' ? 'check_circle' : data?.status === 'started' ? 'change_circle' : ''"></mat-icon>
                      <span class="status-button">{{data?.status ? (data?.status | titlecase) : '-'}}</span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="download">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 text-right"></th>
                  <td mat-cell *matCellDef="let data" class="text-right cursor-pointer download-width result cell-data fw-400 fs-16" (click)="downloadCobReport(data)">
                    <span *ngIf="data?.reportFile" class="pl-20 flex items-center">
                      <mat-icon svgIcon="file_download" class="flex justify-end"></mat-icon>{{'INSTANCE_DETAILS.DOWNLOAD' | transloco }}
                    </span>
                  </td>
                </ng-container>
                <ng-container matColumnDef="cobMenu">
                  <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                  <td mat-cell *matCellDef="let data" class="expand">
                    <button *ngIf="data?.status !== 'completed' && (!data?.completionMode || data?.completionMode !== 'manual')" class="flex w-100-percent justify-end items-center context-menu-icon cursor-pointer"
                      [matMenuTriggerFor]="subMenu" (click)="menuItemClick()">
                      <mat-icon svgIcon="more_vert"></mat-icon>
                    </button>
                    <mat-menu #subMenu [xPosition]="'before'" class="context-menu-dropdown">
                      <div class="flex flex-col">
                        <button class="menu-button" (click)="menuClick(data)">
                          <div class="flex flex-row justify-start items-center">
                            <mat-icon svgIcon="check" class="icon-md"></mat-icon>
                            <div class="mat-body fw-400">{{'INSTANCE_DETAILS.MARK_AS_COMPLETED' | transloco }}</div>
                          </div>
                        </button>
                      </div>
                    </mat-menu>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="cobColumns.length" [ngClass]="{'inner-table': element === expandedElement}" class="inner-table">
                    <div class="example-element-detail flex-col" *ngIf="element === expandedElement" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                      <ng-container *ngIf="dataSourceInnerCob?.length > 0; else noInnerLogFound">
                      <table mat-table [dataSource]="dataSourceInnerCob" multiTemplateDataRows class="mat-elevation logs">
                        <ng-container matColumnDef="stage">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STAGE' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.stage ? data?.stage : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="startTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase}}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.startTime ? (data?.startTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="endTime">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.endTime ? (data?.endTime | date: 'dd MMM yyyy, HH:mm' + ' UTC') : '-'}} </td>
                        </ng-container>
                        <ng-container matColumnDef="duration">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.DURATION' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-400 fs-16">{{data?.startTime | timeDuration : data?.endTime : '-'}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                          <td mat-cell *matCellDef="let data" class="status-width route-id cell-data fw-400 fs-16">
                            <div class="flex flex-row justify-center items-center service-version width-status pt-8 pr-16 pb-8 pl-16 mr-24" [ngClass]="data?.status === 'completed' || data?.status === 'started' ? 'success-cob' : data?.status === 'not started' ? 'not-started' : 'failed-cob'">
                              <mat-icon *ngIf="data?.status !== 'not started'" class="icon-md p-2 mr-4" [svgIcon]="data?.status === 'failed' ? 'error' : (data?.status === 'completed' || data?.status === 'started' ? 'check_circle' : '')"></mat-icon>
                              <span class="status-button">{{data?.status ? (data?.status | titlecase) : '-'}}</span>
                            </div>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="message">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"></th>
                          <td mat-cell *matCellDef="let data" class="route-id msg-width cell-data fw-400 fs-16">
                            <span *ngIf="data?.status === 'failed' || data?.status === DeployStatus.COB_NOT_STARTED" class="pl-20 flex items-center cursor-pointer" (click)="messageClick(data?.message)">
                              <mat-icon class="icon-md p-2 mr-4" svgIcon="chat"></mat-icon>{{'INSTANCE_DETAILS.MSG' | transloco }}
                            </span>
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerCobColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerCobColumns;"></tr>
                        </table>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="cobColumns"></tr>
                <tr mat-row *matRowDef="let element; columns: cobColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element">
                </tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
              </table>
            </div>
            <div *ngIf="cobTable?.length" class="p-12">
              <app-paginator [length]="cobTable?.length" [pageSizeOptions]="[10, 15, 20]"
                  [pageSize]="cobPaginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="cobPageChanged($event)"></app-paginator>
            </div>
            <mat-card *ngIf="showSpinner" class="flex spinner-container spinner">
              <mat-spinner diameter="24"
                color="primary"
                mode="indeterminate">
              </mat-spinner>
            </mat-card>
            <ng-template #noInnerCobFound>
              <div>
              <table [dataSource]="dataSourceInnerCob" mat-table class="mat-elevation logs">
                  <ng-container matColumnDef="stage">
                    <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STAGE' | transloco | uppercase }} </th>
                  </ng-container>
                  <ng-container matColumnDef="startTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.START_TIME' | transloco | uppercase}}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                  </ng-container>
                  <ng-container matColumnDef="endTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.END_TIME' | transloco | uppercase }}{{'INSTANCE_DETAILS.UTC' | transloco }}</th>
                  </ng-container>
                  <ng-container matColumnDef="duration">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.DURATION' | transloco | uppercase }}</th>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_DETAILS.STATUS' | transloco | uppercase }}</th>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="innerCobColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: innerCobColumns;"></tr>
              </table>
              </div>
              <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
              </div>
            </ng-template>
          </div>
        </div>
        <div *ngIf="showLoader">
          <mat-card class="flex spinner-container load-spinner">
            <mat-spinner diameter="24"
              color="primary"
              mode="indeterminate">
            </mat-spinner>
          </mat-card>
        </div>
        <ng-template #noCob>
          <div class="flex justify-center pt-8 pb-8 fw-400">
            {{'INSTANCE_LIST.NO_COB_MESSAGE' | transloco }}
          </div>
          <div *ngIf="((((data.deploymentClass === DeploymentClass.D || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_NONPII]) || (data.deploymentClass === DeploymentClass.B || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_PII]) || (data.deploymentClass === DeploymentClass.A || data.deploymentClass === DeploymentClass.C) && featuresMap[FeatureKeys.COB_LIVE])" class="flex justify-center pt-12">
            <button class="flex justify-center items-center tenant-gradient mat-subtitle-2" [ngClass]="{'disabled': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !isCobLoaded) : !isCobLoaded}" mat-button type="button" (click)="configureCob()">{{'INSTANCE_DETAILS.CONFIGURE_COB' | transloco }}</button>
          </div>
        </ng-template>
        } @else {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
            <img src="/assets/images/feature_not_available.png">
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
          </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': backupResults?.length === 0}">{{'TENANT_DETAILS.DATABASE_BACKUP' | transloco }}</span>
        </ng-template>
        @if (isAWS) {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-50 fs-16">
            <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
          </div>
        } @else if ((featuresMap[FeatureKeys.DATABASE_SNAPSHOT_NONPII]
        || featuresMap[FeatureKeys.DATABASE_SNAPSHOT_PII]
        || featuresMap[FeatureKeys.DATABASE_SNAPSHOT_LIVE]
        || featuresMap[FeatureKeys.DATABASE_ARCHIVE_LIVE])) {
          <div class="p-24 bp-section m-8">
            <span class="mat-subtitle-1 pb-4 fw-600 fs-20 bp-header">{{'TENANT_DETAILS.DATABASE_BACKUP' | transloco }}</span>
            <mat-divider class="bp-divider mb-16"></mat-divider>
            <div class="db-table">
              <div *ngIf="isBackupTableLoaded" [ngClass]="[(backupResults?.length === 0) ? 'flex justify-center items-center' : 'flex justify-end']">
                <app-search-filter class="mr-20" *ngIf="backupResults?.length > 0" (keyup)="searchBp($event)" [placeholder]="'SEARCH.SEARCH'"></app-search-filter>
                <span *ngIf="backupResults?.length > 0" class="separator mt-4"></span>
                <button [ngClass]="{'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess) : !INSTANCE_AVAILABLE_STATUS.includes(instance?.status) || dbInprogess}" class="tenant-gradient mat-subtitle-2 bp-btn mb-16 ml-20" mat-button type="button"
                  matTooltipClass="above" matTooltipPosition="above" [matTooltip]="(dbInprogess && INSTANCE_AVAILABLE_STATUS.includes(instance?.status)) ? ('TEST_RESULTS.DATABASE_BACKUP_INPROGRESS' | transloco) : ''" (click)="data.status !== DeployStatus.TERMINATED && !dbInprogess && INSTANCE_AVAILABLE_STATUS.includes(instance?.status) ? createNewBackup() : ''">{{'INSTANCE_DETAILS.CREATE_NEW_BACKUP' | transloco }}</button>
              </div>
              <div class="flex justify-end mb-16">
                <div class="flex flex-row flex-wrap justify-start">
                  <ng-container *ngIf="dbStatus?.length > 0">
                    <div class="flex flex-row items-center">
                      <span *ngFor="let status of dbFilterTags" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                        {{status | titlecase}}
                        <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="closeDbMenu(status)"></mat-icon>
                      </span>
                    </div>
                  </ng-container>
                  <div class="flex flex-row items-center mr-16">
                    <span *ngIf="dbStatus?.length > 0" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
                      (click)="resetDbFilter()">
                      {{ 'BUTTONS.CLEAR_ALL' | transloco }}
                    </span>
                  </div>
                </div>
                <div *ngIf="backupResults?.length > 0">
                  <button class="flex context-menu-icon-filter" (click)="dbFilterColumns()">
                    <mat-icon svgIcon="filter_alt" class="mr-4 mt-2"></mat-icon>
                    <span class="fw-500 filters">{{'TENANT_LIST.FILTERS' | transloco}}</span>
                  </button>
                  <!-- <button class="flex justify-center items-center filters-menu" [matMenuTriggerFor]="dbMenu" (menuClosed)="menuClose()">
                    <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                    <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
                  </button> -->
                  <mat-menu #dbMenu [xPosition]="'before'" class="db-menu-dropdown p-16">
                    <div class="flex">
                      <div *ngIf="data?.dataZone === DataZone?.LIVE" class="flex-col">
                        <div class="flex-row">
                        <span class="db-status mat-body-1 fw-500 mt-24 mb-16">{{'ISB.DB_TYPE' | transloco }}</span>
                        <div class="flex flex-row mr-40 mb-16" *ngFor="let dbType of dbTypeFilter" (click)="$event.stopPropagation()">
                          <mat-icon [svgIcon]="dbType?.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox icon-md-1 mr-8" (click)="checkRadioButton(dbType)"></mat-icon>
                          <div class="fw-500">{{dbType?.name}}</div>
                        </div>
                      </div>
                      <div class="flex-row mt-34">
                        <span class="db-status mat-body-1 fw-500 mt-24 mb-16">{{'ADD_SOLUTION.NAME' | transloco }}</span>
                        <div class="flex flex-row mr-40 mb-16" *ngFor="let dbName of dbNameFilter" (click)="$event.stopPropagation()">
                          <mat-icon [svgIcon]="dbName?.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox icon-md-1 mr-8" (click)="checkRadioButton(dbName)"></mat-icon>
                          <div class="fw-500">{{dbName?.name}}</div>
                        </div>
                      </div>
                      </div>
                      <div class="flex-col">
                        <span class="db-status mat-body-1 fw-500 mt-24 mb-16">{{'EXTERNAL_INSTANCE.STATUS' | transloco }}</span>
                        <div class="flex flex-row mb-16" *ngFor="let dbStatus of dbStatusFilter" (click)="$event.stopPropagation()">
                          <mat-icon [svgIcon]="dbStatus?.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox icon-md-1 mr-8" (click)="checkRadioButton(dbStatus)"></mat-icon>
                          <div class="fw-500">{{dbStatus?.name}}</div>
                        </div>
                      </div>
                    </div>
                    <mat-divider class="neutral-2 mt-16"></mat-divider>
                    <div class="flex justify-end mat-subtitle-1 mb-0 fw-700 fs-16 cursor-pointer" (click)="applyFilter($event)">{{'BUTTONS.APPLY' | transloco}}</div>
                  </mat-menu>
                </div>
              </div>
              <ng-container *ngIf="isBackupTableLoaded && backupTable?.length > 0">
                <table mat-table [dataSource]="dataSourceDb"  matSort (matSortChange)="sortDbData($event)" multiTemplateDataRows class="w-100-percent db-table" >
                  <ng-container matColumnDef="databaseName">
                    <th mat-header-cell *matHeaderCellDef>{{'INSTANCE_DETAILS.NAME' | transloco | uppercase}}</th>
                      <td mat-cell *matCellDef="let element" class="name"><span class="db-name"><span class="text-ellipsis cursor-pointer clickable" (click)="openDetails(element)">{{element?.backupType === 'archive' && element?.to?.fileName ? element?.to?.fileName : element?.backupType === 'snapshot' && element?.to?.databaseName ? element?.to?.databaseName : element?.typeTag === 'PostgreSQL' && element?.to?.serverName ? element?.to?.serverName : 'N/A'}}</span>
                       <mat-icon *ngIf="(element?.typeTag === 'PostgreSQL' && element?.to?.serverName) || (element?.to?.fileName && element?.backupType === 'archive') || ( element?.to?.databaseName && element?.backupType === 'snapshot')" svgIcon="info" class="cursor-pointer icon-sm ml-6 mt-2" matTooltipClass="above" matTooltipPosition="above" [matTooltip]="element?.typeTag === 'PostgreSQL' ? element?.to?.serverName : element?.backupType === 'snapshot' ? element?.to?.databaseName : element?.backupType === 'archive' ? element?.to?.fileName : '-'"></mat-icon>
                      <span *ngIf="( element?.backupType === 'archive') || ( element?.backupType === 'snapshot')" class="pl-8 pr-8 backup-tag fs-10 fw-700 ml-8 mr-12" [ngClass]="{'archive': element?.backupType === 'archive', 'snapshot': element?.backupType === 'snapshot'}">{{element?.backupType | uppercase }}</span>
                      <span *ngIf="((element?.backupType === 'archive') || (element?.backupType === 'snapshot')) && element?.typeTag" class="pl-8 pr-8 backup-tag fs-10 fw-700 ml-8 mr-12" [ngClass]="{'archive': element?.typeTag === 'MSSQL', 'snapshot': element?.typeTag === 'PostgreSQL'}">{{element?.typeTag}}</span>
                    </span></td>
                  </ng-container>
                  <ng-container matColumnDef="applicationStartTime">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'INSTANCE_DETAILS.CREATED_DATE_UTC' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name"><div>{{element?.createdAt | date: 'dd MMM yyyy, HH:mm' : 'UTC'}}</div></td>
                  </ng-container>
                  <ng-container matColumnDef="expiryDays">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'INSTANCE_DETAILS.RETENTION_DATE_UTC' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name"><div>{{element?.expirationDate | date: 'dd MMM yyyy'}} ({{element?.expiryDays}} days)</div></td>
                  </ng-container>
                  <ng-container matColumnDef="pitrTimestamp">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'INSTANCE_DETAILS.SNAPSHOT_DATE_TIME' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name"><div>{{element?.pitrTimestamp | date: 'dd MMM yyyy, HH:mm' : 'UTC'}}</div></td>
                  </ng-container>
                  <ng-container matColumnDef="ticketNumber">
                    <th mat-header-cell *matHeaderCellDef>{{'INSTANCE_DETAILS.JIRA_TICKET' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name"><div class="cursor-pointer underline" (click)="ticketNumberClick(element?.ticketNumber)">{{element?.ticketNumber}}</div></td>
                  </ng-container>
                  <ng-container matColumnDef="initiatedBy">
                    <th mat-header-cell *matHeaderCellDef>{{'INSTANCE_DETAILS.MODIFIED_BY_DB' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name">
                      <div class="ml-24">
                        <span *ngIf="!element?.modifiedBy && !element?.createdBy">-</span>
                        <img *ngIf="element?.modifiedBy || element?.createdBy" matTooltipClass="tooltip-inner left account-db" [matTooltip]="element?.modifiedBy ? element?.modifiedBy : element?.createdBy" [src]="'assets/images/account_circle.svg'" alt="Image" [matTooltipPosition]="'left'" />
                      </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>{{'INSTANCE_DETAILS.STATUS' | transloco | uppercase}}</th>
                    <td mat-cell *matCellDef="let element" class="name">
                    <div class="flex items-center">
                      <mat-icon *ngIf="element?.isExpired" svgIcon="error" class="icon-md-1 p-2 mr-6 expired-icon" matTooltipClass="above" matTooltipPosition="above" matTooltip="{{'INSTANCE_DETAILS.EXPIRED' | transloco}}"></mat-icon>
                      <div class="flex items-center status pl-8 pr-8 pt-4 pb-4" [ngClass]="element?.isExpired ? 'expired-completed' : element?.status">
                        <span>
                          <mat-icon *ngIf="element?.status === 'completed'" svgIcon="check_circle_filled" class="icon-md p-2 mr-6" [ngClass]="element?.isExpired ? 'expired-completed' : element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'failed'" svgIcon="close" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'expired'" svgIcon="error" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'inprogress'" svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'deleted'" svgIcon="check_circle_filled" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'deleting'" svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'deletion_failed'" svgIcon="close" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'extended'" svgIcon="check_circle_filled" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                          <mat-icon *ngIf="element?.status === 'extention_failed'" svgIcon="close" class="icon-md p-2 mr-6" [ngClass]="element?.status"></mat-icon>
                        </span>
                        <span>
                        {{element?.status === 'deletion_failed'? ('INSTANCE_DETAILS.DATABASE_BACKUP.DELETE_FAILED' | transloco) : element?.status === 'extention_failed'? ('INSTANCE_DETAILS.DATABASE_BACKUP.EXTEND_FAILED' | transloco) : element?.status | titlecase}}
                        </span>
                      </div>
                      <div class="flex flex-col red-oval mt-4 ml-12">
                        <mat-icon *ngIf="element?.errors && element?.errors?.length > 0 && element?.status !== 'completed'" svgIcon="warning_amber" class="w-24 cursor-pointer" (click)="showErrorDetails(element)"></mat-icon>
                    </div>
                    </div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="delete">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let element" class="name">
                      <div *ngIf="(element?.status === 'extended' || element?.status === 'expired' || element?.status === 'completed' || element?.status === 'deletion_failed' || element?.operation === 'update') && element?.backupType !== 'archive'" class="flex items-center pl-8 pr-8 pt-2 pb-2">
                        <button class="flex justify-center items-center context-menu-icon" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (instance?.status | isNotIn: INSTANCE_AVAILABLE_STATUS) || ['inprogress'].includes(element?.status)) : (instance?.status | isNotIn: INSTANCE_AVAILABLE_STATUS) || ['inprogress'].includes(element?.status)"
                        [matMenuTriggerFor]="dbDeleteActionsMenu">
                        <mat-icon svgIcon="more_vert"></mat-icon>
                        </button>
                        <mat-menu #dbDeleteActionsMenu [xPosition]="'before'" class="context-menu-dropdown">
                          <div *ngIf="INSTANCE_AVAILABLE_STATUS.includes(instance?.status)" class="flex-col delete" matTooltipClass="above" matTooltipPosition="above">
                            <button class="delete-button" (click)="openDeleteForm(element)">
                              <div class="flex items-center">
                                <mat-icon svgIcon="delete" class="icon redDelete"></mat-icon>
                                <div class="mat-body-1 m-0 fw-400 redDelete">{{'BUTTONS.DELETE' | transloco}}</div>
                              </div>
                            </button>
                          </div>
                          <div *ngIf="element?.status === 'completed' && element?.backupType === 'snapshot' || element?.operation === 'update'" class="flex-col" matTooltipClass="above" matTooltipPosition="above">
                            <button (click)="extendBackup(element)">
                              <div class="flex items-center">
                                <mat-icon svgIcon="more_time" class="icon"></mat-icon>
                                <div class="mat-body-1 m-0 fw-400">{{'INSTANCE_DETAILS.EXTEND_BACKUP' | transloco}}</div>
                              </div>
                            </button>
                          </div>
                        </mat-menu>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="backupTableColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: backupTableColumns;"></tr>
                </table>
                <div *ngIf="backupTable?.length > 10" class="p-12">
                  <app-paginator [length]="backupTable?.length" [pageSizeOptions]="[10, 15, 20]"
                      [pageSize]="dbPaginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="dbPageChanged($event)"></app-paginator>
                </div>
              </ng-container>
              <ng-container *ngIf="isBackupTableLoaded && dataSourceDb?.filteredData?.length === 0 && backupResults?.length !== 0">
                <div class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 mt-60">
                  <img src="/assets/images/instance-not-found-small.png"> <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
                </div>
              </ng-container>
              <div *ngIf="!isBackupTableLoaded" class="flex items-center justify-center loader">
                <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
              </div>
            </div>
          </div>
        } @else {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-30 fs-16">
            <img src="/assets/images/feature_not_available.png">
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_AVAILABLE' | transloco}}</div>
          </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{'TENANT_DETAILS.INVENTORY' | transloco }}</span>
        </ng-template>
        @if (isAWS) {
          <div class="flex flex-col items-center justify-center pt-8 pb-10 mt-50 fs-16">
            <mat-icon svgIcon="report_problem" class="icon-md-2 h-50 w-50 not-supported"></mat-icon>
            <div class="mt-10 feature-not-avaliable">{{'FEATURE.FEATURE_NOT_SUPPORTED_FOR_AWS' | transloco}}</div>
          </div>
        } @else {
        <div class="flex w-100-percent inventory-tabs">
          <div class="flex justify-between normal p-24 fw-400 fs-18 mr-10" [ngClass]="{'active fw-600': products}" (click)="inventoryTabs('products')">
            <span>{{'TENANT_DETAILS.PRODUCTS' | transloco}}</span>
            <span>{{inventoryProductsData?.length > 0 ? inventoryProductsData?.length : 0}}</span>
          </div>
          <div class="flex normal justify-between normal p-24 fw-400 fs-18 mr-10" [ngClass]="{'active fw-600': components}" (click)="inventoryTabs('components')">
            <span>{{'TENANT_DETAILS.COMPONENTS' | transloco}}</span>
            <span>{{inventoryComponentData?.length > 0 ? inventoryComponentData?.length : 0}}</span>
          </div>
          <div class="flex normal justify-between normal p-24 fw-400 fs-18 mr-10" [ngClass]="{'active fw-600': cloud}" (click)="inventoryTabs('cloud')">
            <span>{{'TENANT_DETAILS.CLOUD_RESOURCES' | transloco}}</span>
            <span>{{searchTerm?.length > 0 && searchedResult ? (searchedResult.length > 0 ? searchedResult.length : 0) : (cloudResourceData && cloudResourceData?.length) ? (cloudResourceData?.length > 0 ? cloudResourceData?.length : 0) : '0'}}</span>
          </div>
          <div class="flex normal justify-between normal p-24 fw-400 fs-18 mr-10" [ngClass]="{'active fw-600': kubernetes}" (click)="inventoryTabs('kubernetes')">
            <span>{{'TENANT_DETAILS.KUBERNETES' | transloco}}</span>
            <span>{{inventoryKubernetesData?.length > 0 ? inventoryKubernetesData?.length : 0 }}</span>
          </div>
        </div>
        <!-- inventory product details -->
        <div *ngIf="products" class="flex flex-row justify-between">
           <div class="flex items-center header-section-cloud-inventory flex-wrap">
            <div class="mat-subtitle-2 mb-0 fs-24 fw-600 mt-24 mb-12">{{'TENANT_DETAILS.PRODUCT_DETAILS' | transloco}}
              <span>
                ({{searchProductTerm?.length > 0 && searchedProductsRes ? (searchedProductsRes.length > 0 ? searchedProductsRes.length : 0) : (inventoryProductsData && inventoryProductsData?.length) ? (inventoryProductsData?.length > 0 ? inventoryProductsData?.length : 0) : '0'}})
              </span>
            </div>
            <app-search-filter *ngIf="inventoryProductsData?.length > 0 || isProdFilterResultEmpty" class="mt-24 mb-12 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchProducts($event)"></app-search-filter>
            <div *ngIf="inventoryProductsData?.length > 0 || isProdFilterResultEmpty" class="vertical-dash-inventory ml-12 mr-12 mt-24 mb-12"></div>
            <div *ngIf="inventoryProductsData?.length > 0 || isProdFilterResultEmpty" class="mt-24 mb-12" >
              <button class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" (click)="filterProductColumns()">
                <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
              </button>
            </div>
          </div>

            <div class="flex justify-end gap-4 mt-24 mb-12 w-1/2" >
              <button [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" (click)="syncInventoryCloud()">
                <mat-icon class="mr-4" svgIcon="sync"></mat-icon>
                <span class="mat-body-1 fw-500">{{'INVENTORY.SYNC' | transloco }}  </span>
              </button>
              <button *ngIf="inventoryProductsData?.length > 0" [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center download-csv pl-4 pr-4 h-34" (click)="downloadCSV('products')">
                <mat-icon svgIcon="file_download"></mat-icon>
              </button>
            </div>
            </div>

        <div *ngIf="products" class="flex flex-row row-gap flex-wrap items-center mb-12">
          <div class="mr-4 pt-8 pb-4 filtered-items row-gap flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedVersion?.length > 0">
            <span class="fw-400">{{ 'INSTANCE_DETAILS.VERSION' | transloco }}</span>
            <span *ngFor="let version of selectedVersion" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16 ml-8">
              {{getProductVersions(version)}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelVersionFilter(version)"></mat-icon>
            </span>
          </div>
           <div class="mr-4 pt-8 pb-4 filtered-items row-gap flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedIsManaged?.length > 0">
            <span class="fw-400">{{ 'INSTANCE_DETAILS.IS_MANAGED' | transloco }}</span>
            <span *ngFor="let isManaged of selectedIsManaged" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16 ml-8">
              {{getProductIsManaged(isManaged)}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelIsManagedFilter(isManaged)"></mat-icon>
            </span>
          </div>
          <div class="flex flex-row items-center">
            <span *ngIf="selectedVersion?.length > 0" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetProductFilter()">
              {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
          </div>
        </div>
        <div *ngIf="products" class="flex flex-col route-table mb-16">
          <app-table [initialDataSource]="inventoryProductsData" [displayColumns]="inventoryProductColumns" [dataLoading]="inventoryLoading" [showSkeletonLoader]="true" [searchTerm]="searchProductTerm" page="productInventory" [dataSourceLength]="true" [initialCreate]="inventoryProducts?.length === 0" pageName="productInventory" (searchedResults)="searchedProductItems($event)"></app-table>
        </div>
        <!-- inventory component details -->
        <div *ngIf="components" class="flex flex-col component-details">
          <div class="flex flex-row items-center justify-between">
            <div  class="flex items-center">
              <div class="mat-subtitle-2 mb-0 fs-24 fw-600 pt-20">{{'TENANT_DETAILS.COMPONENTS' | transloco}}
                <span>({{searchInventoryTerm?.length > 0 && searchedComponentResult ? searchedComponentResult.length : !inventoryComponents ? "0" : inventoryComponents?.length}})
                </span>
              </div>
              <app-search-filter *ngIf="inventoryComponentData && inventoryComponentData.length>0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchInventory($event)"></app-search-filter>
              <div *ngIf="inventoryComponentData && inventoryComponentData.length>0" class="vertical-dash ml-12 mr-12 mt-20"></div>
              <div *ngIf="inventoryComponentData && inventoryComponentData.length>0" class="mt-20" >
                <button class="flex justify-center items-center filter pl-6 pr-16 h-34" (click)="filterInventoryComponent()">
                  <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                  <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
                </button>
              </div>
            </div>
            <div class="flex items-center mr-10">
              <button [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center filter pl-6 pr-16 h-34 mt-20" (click)="syncInventoryCloud()">
                <mat-icon class="mr-4" svgIcon="sync"></mat-icon>
                <span class="mat-body-1 fw-500">{{'INVENTORY.SYNC' | transloco }}</span>
              </button>
              <button *ngIf="inventoryComponents?.length > 0" [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center ml-16 mt-20 download-csv pl-4 pr-4 h-34" (click)="downloadCSV('components')">
                <mat-icon svgIcon="file_download"></mat-icon>
              </button>
            </div>
          </div>
          <div class="flex flex-row items-center">
            <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedStatus?.length > 0">
              <span *ngFor="let status of selectedStatus" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
              {{getStatusLabel(status)}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelComponentFilter(status)"></mat-icon>
              </span>
            </div>
            <div class="flex flex-row items-center mt-20">
              <span *ngIf="selectedStatus?.length > 0 " class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"(click)="resetComponentFilter()">{{ 'BUTTONS.CLEAR_ALL' | transloco }}</span>
            </div>
          </div>
          <div class="pt-8">
            <app-table  [searchTerm]="searchInventoryTerm"  [initialDataSource]="inventoryComponents"   [displayColumns]="inventoryComponentColumns" [dataLoading]="inventoryLoading" [showSkeletonLoader]="true"  [dataSourceLength]="true" page="inventory"  pageName="inventory" [initialCreate]="inventoryComponentData?.length === 0" (searchedResults)="searchedComponentItems($event)"></app-table>
          </div>
        </div>
        <div *ngIf="cloud" class="flex flex-row justify-between">
          <div class="flex items-center header-section-cloud-inventory flex-wrap">
            <div class="mat-subtitle-2 mb-0 fs-24 fw-600 mt-24 mb-12">{{'TENANT_DETAILS.CLOUD_RESOURCES' | transloco}}
              <span>
                ({{searchTerm?.length > 0 && searchedResult ? (searchedResult.length > 10 ? searchedResult.length : '0'+ searchedResult.length) : (cloudResourceData && cloudResourceData?.length) ? (cloudResourceData?.length > 10 ? cloudResourceData?.length : '0'+ cloudResourceData?.length) : '0'}})
              </span>
            </div>
            <app-search-filter *ngIf="cloudResourceData?.length > 0 " class="mt-24 mb-12 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchCloud($event)"></app-search-filter>
            <div *ngIf="cloudResourceData?.length > 0" class="vertical-dash-inventory ml-12 mr-12 mt-24 mb-12"></div>
            <div *ngIf="cloudResourceData?.length > 0" class="mt-24 mb-12" >
              <button class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" (click)="filterCloudColumns()">
                <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
              </button>
            </div>
          </div>

            <div class="flex justify-end gap-4 mt-24 mb-12 w-1/2" >
              <button [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" (click)="syncInventoryCloud()">
                <mat-icon class="mr-4" svgIcon="sync"></mat-icon>
                <span class="mat-body-1 fw-500">{{'INVENTORY.SYNC' | transloco }}</span>
              </button>
              <button *ngIf="cloudResourceData?.length > 0" [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES" class="flex justify-center items-center download-csv pl-4 pr-4 h-34" (click)="downloadCSV('cloudResources')">
                <mat-icon svgIcon="file_download"></mat-icon>
              </button>
              <button *ngIf="cloudResourceData?.length > 0" class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" (click)="viewInventoryCloud()">
                <mat-icon class="mr-4" svgIcon="bar_chart"></mat-icon>
                <span class="mat-body-1 fw-500">{{'INVENTORY.VIEW_TYPES' | transloco }}</span>
              </button>
            </div>
          </div>

        <div *ngIf="cloudResourceData?.length > 0 && cloud" class="flex flex-row row-gap flex-wrap items-center mb-12">
          <div class="mr-4 pt-8 pb-4 filtered-items row-gap flex flex-wrap items-center fs-16 fw-500" *ngIf="selectedType?.length > 0">
            <span *ngFor="let type of selectedType" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
              {{getType(type)}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelTypeFilter(type)"></mat-icon>
            </span>
          </div>
          <div class="flex flex-row items-center">
            <span *ngIf="selectedType?.length > 0" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg" (click)="resetInventoryFilter()">
              {{ 'BUTTONS.CLEAR_ALL' | transloco }}
            </span>
          </div>
        </div>
        <div *ngIf="cloud" class="flex flex-col route-table mb-16">
          <app-table [initialDataSource]="cloudResourceData" [displayColumns]="inventoryColumns" [dataLoading]="cloudResourceLoader" [showSkeletonLoader]="true" [searchTerm]="searchTerm" page="cloudInventory" [dataSourceLength]="true" [initialCreate]="initialCloudResourceData?.length === 0" pageName="cloudInventory" (searchedResults)="searchedItems($event)"></app-table>
        </div>
        <div *ngIf="kubernetes" class="flex flex-row justify-between">
          <div class="flex items-center header-section-cloud-inventory">
          <div class="mat-subtitle-2 mb-0 fs-24 fw-600 mt-24 mb-24">{{'TENANT_DETAILS.KUBERNETES' | transloco}}
              <span>({{searchKubTerm?.length > 0 && searchedKubernetesRes ?
                searchedKubernetesRes.length : (inventoryKubernetesData?.length > 0 ? inventoryKubernetesData?.length : "0")}})
              </span>
          </div>
            <app-search-filter *ngIf="inventoryKubernetesData?.length > 0" class="mt-24 mb-12 ml-20" placeholder="SEARCH.SEARCH"
              (changed)="searchKubernetes($event)"></app-search-filter>

            </div>
          <div>
            <div class="mt-24 mb-12">
              <button class="flex justify-center items-center edgenetwork-filter pl-6 pr-16 h-34" [disabled]="instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES) : data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES"
                (click)="syncInventoryCloud()" [ngClass]="{ 'disable': instance?.availabilityState ? (instance?.availabilityState !== AvailabilityStatus.RUNNING || (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)) : (data?.status | isNotIn: EXCECUTETEST_ENABLE_STATES)}">
                <mat-icon class="mr-4" svgIcon="sync"></mat-icon>
                <span class="mat-body-1 fw-500">{{'INVENTORY.SYNC' | transloco }}</span>
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="kubernetes" class="flex flex-row fs-16 mb-16 fw-400">{{'INVENTORY.NAME' | transloco}} {{kubernetesName}} </div>

        <div *ngIf="kubernetes" class="flex flex-col route-table mb-16 kubernetes-table">
          <app-table (viewClickKubernetes)="viewKubernetesDetails($event)" [searchTerm]="searchKubTerm" [initialDataSource]="inventoryKubernetesData"
            [displayColumns]="inventoryKubernetesColumns" [dataLoading]="inventoryLoading" [showSkeletonLoader]="true"
            [dataSourceLength]="true" page="kubernetesinventory" pageName="kubernetesinventory"
            [initialCreate]="inventoryKubernetes?.length === 0"
            (searchedResults)="searchedKubernetesItems($event)"></app-table>
        </div>
        }
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span [ngClass]="{'disabled': (metricsPieChartLoaded && configurations?.length === 0 && showActivityLoader && metricsLog?.length === 0)}">{{'TENANT_DETAILS.METRICS' | transloco }}</span>
        </ng-template>
        <div class="p-24 eaas-metrics">
          <div class="flex flex-row justify-between">
            <div class="fw-600 fs-24 mb-20">{{'TENANT_DETAILS.ENVIRONMENT_USAGE' | transloco }}</div>
            <app-month-year-picker (monthChange)="applyMonthFilter($event)" [minDate]="data?.dateCreated"></app-month-year-picker>
          </div>
          <div class="flex flex row">
            <div class="flex flex-col metrics-piechart mb-20 mt-16 p-24">
            <span class="fs-20 fw-500">{{'INSTANCE_DETAILS.RELEASE_PACKAGE' | transloco }}</span>
            <div *ngIf="metricsPieChartLoaded && configurationMonth?.length > 0" class="flex items-center">
              <div echarts [options]="metricsPiechart" class="metrics-chart p-10"></div>
              <div class="flex-col pl-30">
                <div class="chart-label fs-14 fw-500 pb-16">{{'INSTANCE_DETAILS.DEPLOYED' | transloco }}</div>
                <span class="fs-36 fw-500">{{successConfigStates?.length}}<span class="ml-8 mr-8">{{'INSTANCE_DETAILS.OF' | transloco }}</span>{{configurationMonth?.length}}</span>
              </div>
            </div>
            <div *ngIf="!metricsPieChartLoaded" class="flex items-center justify-center metrics-spinner">
              <mat-spinner diameter="20" color="primary" mode="indeterminate"></mat-spinner>
            </div>
            <div *ngIf="metricsPieChartLoaded && configurationMonth?.length === 0" class="no-data flex items-center justify-center pt-8 pb-8 fw-500 fs-16 mt-8 metrics-spinner mb-0 mat-subtitle-1">
              <mat-icon svgIcon="error" class="icon-md-1 metrics-unavailable"></mat-icon>
              <span class="metrics-unavailable ml-4">{{'INSTANCE_DETAILS.USAGE_NOT_AVAILABLE' | transloco }}</span>
            </div>
          </div>
           <div class="flex flex-col total-time-taken mb-20 ml-24 mt-16 p-24">
              <app-time-taken-pie  [runHours]="runHours" [shutDownHours]="shutDownHours" [timetakenChartLoaded]="timetakenChartLoaded" [isResponseOk]="isResponseOk" [isErrorResponse]="isErrorResponse"> </app-time-taken-pie>
            </div>
          </div>
          <div class="flex items-center mb-12">
            <div class="fw-600 fs-24 mat-subtitle-1 mb-0">
              {{'TENANT_DETAILS.ACTIVITY_LOG' | transloco }}<span *ngIf="metricsLog?.length > 0" class="ml-8">({{searchedMetricResult && metricsSearchTerm?.length > 0 ? searchedMetricResult.length : metricLogData?.length}})</span>
            </div>
            <div *ngIf="metricsLog && metricsLog.length > 0" class="ml-16 metrics-search mt--20">
              <app-search-filter *ngIf="metricsLog?.length !== 0" class="mt-20 ml-20" placeholder="SEARCH.SEARCH" (changed)="searchMetrcis($event)"></app-search-filter>
            </div>
            <div *ngIf="metricsLog && metricsLog.length > 0" class="ml-16" >
              <button class="flex justify-center items-center filter pl-6 pr-16 h-36" (click)="filterMetricLogs()">
                <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
                <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
              </button>
            </div>
          </div>
          <div class="flex flex-row items-center">
            <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="selectedMetricAction?.length > 0">
              <span *ngFor="let action of selectedMetricAction" class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
              {{getAction(action)}}
              <mat-icon svgIcon="close" class="ml-6 icon-sm" (click)="cancelMetricAction(action)"></mat-icon>
              </span>
            </div>
            <div class="mt-20 mr-4 pt-8 pb-8 filtered-items flex items-center fs-16 fw-500" *ngIf="metricLogData && metricStartDate && metricEndDate">
              <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-16">
                {{'SCHEDULES.DATE' | transloco}} : {{ datePipe.transform(metricStartDate, 'dd MMM yyyy')+ '- ' + datePipe.transform(metricEndDate, 'dd MMM yyyy') }}
                <mat-icon svgIcon="close" class="ml-8 icon-sm" (click)="cancelMetricDate()"></mat-icon>
              </span>
            </div>
            <div class="flex flex-row items-center mt-20">
              <span *ngIf="selectedMetricAction?.length > 0 || (metricStartDate && metricEndDate) " class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"(click)="resetMetricFilter()">{{ 'BUTTONS.CLEAR_ALL' | transloco }}</span>
            </div>
          </div>
          <div *ngIf="(metricsLog && metricsLog.length > 0) || showActivityLoader ; else noActivityLogFound">
          <app-table [initialDataSource]="metricLogData" [searchTerm]="metricsSearchTerm" [displayColumns]="metricsDisplayColumns" [dataLoading]="showActivityLoader" [showSkeletonLoader]="true" [dataSourceLength]="true" pageName="metricsLog" (searchedResults)="searchedMetricItems($event)"></app-table>
          </div>
          <ng-template #noActivityLogFound>
            <div class="external-package p-24">
              <div *ngIf="isLogFailed || metricsLog?.length === 0" class="no-data flex items-center justify-center pt-8 pb-8 fw-600 fs-20 m-60">
                <img src="/assets/images/instance-not-found-small.png">
                <div class="ml-10">{{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}</div>
              </div>
             </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span>{{'TENANT_DETAILS.SETTINGS' | transloco }}</span>
        </ng-template>
        <div class="settings-log p-24">
          <div class="mat-subtitle-2 fw-600 fs-18 mt-8 mb-10">{{'INSTANCE_DETAILS.LOG_LEVEL_CONFIG' | transloco }}</div>
          <div class="mat-subtitle-2 fw-700 fs-12 mt-8 mb-10">{{'INSTANCE_DETAILS.TYPE' | transloco | uppercase}}</div>
          <div class="flex flex-row self-start mt-12">
            <!-- <div *ngFor="let option of type" (click)="selectOptionsType(option)> -->
              <div *ngFor="let option of type" [ngClass]="{'disabled': isInprogress}" (click)="selectOptionsType(option)">
              <div class="flex flex-row mr-20">
                <mat-icon [svgIcon]="option.selected ? 'radio_button_checked' : 'radio_button_unchecked'" class="checkbox-icon icon-md-1 mr-0"></mat-icon>
                <span class="mt-4 ml-10">{{option.label | titlecase}}</span>
              </div>
            </div>
          </div>
          <!-- <div class="flex flex-row" *ngFor="let option of type">
            <span class="message-color fw-400 fs-14 mt-26" *ngIf="option.selected">{{option.message}}</span>
          </div> -->
        </div>
      </mat-tab>
    </mat-tab-group>
    <app-paginator *ngIf="sftpPaginator || logPaginator" class="p-24" [length]="sftpPaginator ? routeData?.length : (deploymentLog && filteredDeploymentLog ? filteredDeploymentLog?.length : deploymentLogData?.length )" [pageSizeOptions]="[10, 15, 20]"
    [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="sftpPaginator ? pageChanged($event) : logPageChanged($event)"></app-paginator>
   <ng-template #sortIcon let-sort="sort" let-property="property">
      <img *ngIf="!sort || sort.property !== property" class="icon-sm" src="/assets/icons/sort.svg">
      <img *ngIf="sort?.property === property" class="icon-sm" [src]="'/assets/icons/sort-' + sort.direction + '.svg'">
    </ng-template>
  </div>
</div>
<app-paginator class="inner-paginator" [ngClass]="!showResultsPagination || !viewResultsPaginator ? 'hide' : ''"></app-paginator>
